/* eslint-disable react-hooks/exhaustive-deps */
import { preparePdfData } from '../libs/pdfPayload'
import usePrefStore, { awaitPrefsHydrated } from "../stores/prefs"
import { v4 as uuidv4 } from 'uuid'
import { Client, Account, Databases, Query, ID } from 'appwrite'
import { useCallback, useEffect, useState, createContext, useContext, type ReactNode } from "react";
import { logNames } from "../Hooks/useLog"
// import useCollections from "../Hooks/useCollections";
import useModelsStore, { awaitModelsHydrated } from "../stores/models";
import useSalesStore from "../stores/sales";
// import { useLogger } from "../Contexts/Logger";
import useTranslation from '../Hooks/useTranslation';
import moment from 'moment';
import { db as dexie_db } from "../stores/db"
import glob_const from '../libs/glob_const'
import { LOCAL_DATA_VERSIONS, isLocalDataOutdated } from '../libs/localDataVersion'
import { computeKeepCutoffs, planOrderReconciliation, decideReconcileErrorAction } from '../libs/orderLocalRetention'
import { startPerfSession, roughJsonSize } from '../libs/perfTracker'
import useSales from "../Hooks/useSales";
import useHelpers from "../Hooks/useHelpers";
import axios from 'axios'
import { postWebhookWithJwt as postWebhookWithJwtHelper } from "./webhookClient"
import { channelFromPref } from '../libs/pwaChannel'
import { runUpdateCheckpoint } from '../libs/pwaUpdate'
import { applyImpersonationHeader, isImpersonationVerified, impersonationRefusal, logoutSequence, LogoutMode } from '../libs/impersonation'
import { purgeLocalData, PURGE_ALL } from '../libs/purgeLocalData'
import { userOwnPermissions } from '../libs/awPermissions'

// Impersonation (messika-pwa#10) : le SDK appwrite 11.x n'a pas setImpersonateUser*, on pose l'en-tête à la main.
const setImpersonationHeader = (client: any, email: string | null) => { if (client) applyImpersonationHeader(client.headers, email) }
// Impersonation ACTIVE = vérifiée (opérateur mémorisé). Lecture fraîche du store.
const isImpersonating = () => !!usePrefStore.getState().impersonateOperator

const theContext = createContext<any>(undefined)

const AppWriteContext = (() => useContext(theContext))

const fetch_names = {
   // tarifRegions: 'tarifRegions',
   // tarifTrads: 'tarifTrads',
   // models: 'models',
   // customers: 'customers',
   collections: 'collections',
   sous_collections: 'sous_collections',
   univers: 'univers',
   couleurs: 'couleurs',
   countries: 'countries',
   customers: 'customers',
   cycles: 'cycles',
   devises: 'devises',
   etapes: 'etapes',
   familles: 'familles',
   genres: 'genres',
   modeles: 'modeles',
   retail_modeles: 'retail_modeles',
   retail_familles: 'retail_familles',
   // orders: 'orders',
   portes: 'portes',
   typologies: 'typologies',
   tarif_regions: 'tarif-regions',
   tarif_trads: 'tarif-trads',
}

const MAX_FETCH_RETRIES = 5      // Nb de retry sur erreur de fetch (réseau), avec RETRY_PAUSE sec entre chaque
const RETRY_PAUSE = 2000         // Pause entre 2 retry

// Normalise supervised_n1/n2 lus depuis les prefs Appwrite en TABLEAU de customer_ids.
// Selon l'écriture/Appwrite, la valeur peut arriver en tableau, en chaîne CSV ("id1,id2,…")
// ou en chaîne JSON ("[\"id1\",…]"). On gère les trois (sinon Array.isArray échouait → []).
const toSupervisedArray = (v: unknown): string[] => {
   if (Array.isArray(v)) return v.map(String)
   if (typeof v === 'string') {
      const s = v.trim()
      if (!s) return []
      if (s.startsWith('[')) {
         try { const p = JSON.parse(s); if (Array.isArray(p)) return p.map(String) } catch { /* pas du JSON → CSV */ }
      }
      return s.split(',').map(x => x.trim()).filter(Boolean)
   }
   return []
}
// Filtres de type du fetch des commandes — partagés par _fetchOrders et _cleanOrders (ids distants).
// Grand utilisateur : pas de retail (ECR/ECF) sur bi_orders. notEqual multi-valeurs est rejeté par
// AppWrite → deux notEqual (AND). Aucun filtre de type sur `orders`.
const buildOrderTypeFilterQueries = (is_bi: boolean) => {
   const q = []
   if (is_bi && usePrefStore.getState().isGrandUtilisateur) {
      q.push(Query.notEqual('type', 'ECR'))
      q.push(Query.notEqual('type', 'ECF'))
   }
   return q
}
const QUERY_PAGE_SIZE = 750     // Taille d'un bloc de fetch des commandes sur AppWrite (pour éviter saturation sur grosses syncho, genre les Grands Utilisateurs)
const BI_RETENTION_MONTHS = 24   // Fenêtre de rétention locale des bi_orders (purge Dexie au login). Alignée sur le prune serveur.

const AppWriteContextProvider = ({ children }: { children: ReactNode }) => {
   // const [appWriteInitDone, setAppWriteInitDone] = useState<any>()  // undefined = pas encore testé, true = OK, false = afficher page "login"
   const [client, setClient] = useState(null)
   const [account, setAccount] = useState(null)
   // Client dédié à createJWT() UNIQUEMENT (messika-pwa#13) : jamais d'en-tête d'impersonation, même session.
   const [jwtAccount, setJwtAccount] = useState(null)
   const [db, setDb] = useState(null)
   const [otp, setOtp] = useState(null)
   const [currentUserId, setCurrentUserId] = useState<string | null>(null)   // ID AppWrite du user loggé (pour dériver le rôle effectif retail par order)
   // const [canSubscribe, setCanSubscribe] = useState(false)
   // const { log } = useLogger()
   //
   // const appWriteEndpoint = usePrefStore((state) => state.appWriteEndpoint)
   // const appWriteProjectId = usePrefStore((state) => state.appWriteProjectId)
   // const isLogged = usePrefStore((state) => state.isLogged)
   // const setIsLogged = usePrefStore((state) => state.setIsLogged)
   const { appWriteEndpoint, appWriteProjectId, appWriteDatabaseId, appWriteCollStockId, appWriteCollOtpId, appWriteCollCustomersId, appWriteCollBiOrdersId, appWriteCollOrdersId, appWriteCollPDFId, appWriteCollUdidId, isLogged, setIsLogged, appWriteCollListsId, appWriteCollTarifsId, appWriteCollVentesRALId, appWriteCollConfiesId, appWriteCollConfiesRALId, setCurTimeout, currentLang, login, udid, pwaApiEndpoint, setIsGrandUtilisateur } = usePrefStore()
   //
   const { miscLogs, getVersion, formatNumber } = useHelpers()
   //
   const { getOrderById, order_status, type_order, updateOrderLocally } = useSales()
   //
   // const { fetch_names, fetchList } = useCollections()
   //
   const {
      tarif_regions,
      setCollections, checksum_collections, setChecksumCollections,
      setSousCollections, checksum_sous_collections, setChecksumSousCollections,
      setUnivers, checksum_univers, setChecksumUnivers,
      setCouleurs, checksum_couleurs, setChecksumCouleurs,
      setCycles, checksum_cycles, setChecksumCycles,
      setDevises, checksum_devises, setChecksumDevises,
      setEtapes, checksum_etapes, setChecksumEtapes,
      setFamilles, checksum_familles, setChecksumFamilles,
      setGenres, checksum_genres, setChecksumGenres,
      setModels, checksum_models, setChecksumModels,
      setRetailModels, checksum_retail_models, setChecksumRetailModels,
      setRetailFamilles, checksum_retail_familles, setChecksumRetailFamilles,
      setPortes, checksum_portes, setChecksumPortes,
      setTypologies, checksum_typologies, setChecksumTypologies,
      setTarifRegions, checksum_tarif_regions, setChecksumTarifRegions,
      setTarifTrads, checksum_tarif_trads, setChecksumTarifTrads,
      setTarifs, checksums_tarifs, setChecksumsTarifs,
   } = useModelsStore()

   const {
      setCountries, checksum_countries, setChecksumCountries,
      last_updated_customers, setLastUpdatedCustomers,
      last_updated_ventes_ral, setLastUpdatedVentesRAL,
      last_updated_confies, setLastUpdatedConfies,
      last_updated_confies_ral, setLastUpdatedConfiesRAL,
      last_updated_bi_orders, setLastUpdatedBiOrders,
      last_updated_orders, setLastUpdatedOrders,
   } = useSalesStore()
   //
   const { trans, transWithParams } = useTranslation();

   // console.log(logNames.appWrite, 'useAppwrite()')

   // console.log('*** AppWriteContext');

   /*
   ██ ███    ██ ██ ████████
   ██ ████   ██ ██    ██
   ██ ██ ██  ██ ██    ██
   ██ ██  ██ ██ ██    ██
   ██ ██   ████ ██    ██
   */

   useEffect(() => {
      let cancelled = false
      if (appWriteEndpoint && appWriteProjectId) {
       // Le store prefs est hydraté de façon asynchrone (IndexedDB) : sans cette attente, l'état d'impersonation
       // n'est pas encore lu et l'en-tête n'est pas reposé avant account.get() / getPrefs().
       awaitPrefsHydrated().then(() => {
         if (cancelled) return
         const _client = new Client()
         const _account = new Account(_client)
         const _db = new Databases(_client)

         // console.log(logNames.appWrite, 'Client', _client)
         // console.log(logNames.appWrite, 'Account', _account)
         // console.log(logNames.appWrite, 'DB', _db)

         setClient(_client)
         setAccount(_account)
         setJwtAccount(new Account(new Client().setEndpoint(appWriteEndpoint).setProject(appWriteProjectId)))
         setDb(_db)

         _client
            .setEndpoint(appWriteEndpoint)
            .setProject(appWriteProjectId)
         // Impersonation active (rechargement de la PWA) : l'en-tête est reposé AVANT toute requête (account.get ci-dessous).
         // Pendant la phase « cible choisie, pas encore connecté » (pas d'opérateur), on ne le pose pas : doLogin le fera après la session.
         const imp = usePrefStore.getState()
         if (imp.impersonateOperator && imp.impersonateTarget) setImpersonationHeader(_client, imp.impersonateTarget)
         console.log(logNames.appWrite, `Connexion Appwrite(${appWriteEndpoint}, ${appWriteProjectId})`, _client)

         console.log('Check Account', appWriteEndpoint, appWriteProjectId);
         _account.get().then(async (data) => {
            console.log('Account OK', data);
            setCurrentUserId(data?.$id ?? null)
            usePrefStore.getState().setUserName(data?.name ?? '')   // nom auth AW (affiché dans le bloc debug)
            // Reprise de session : on doit aussi rafraîchir les prefs (serverRetailRole,
            // isRetailManager, supervisedN1/N2) — sinon on garde la valeur persistée
            // d'un état antérieur (potentiellement null pour un user récemment créé ou
            // upgradé côté dashboard). Sans ça, le bloc debug affiche "Rôle serveur : aucun"
            // pour un user-client qui s'est juste reconnecté via cookie.
            try {
               const prefs = await _account.getPrefs()
               setIsGrandUtilisateur(prefs.grand_utilisateur === true)
               // Bug #4 corrigé : la restauration de session prenait en compte uniquement user_type,
               // ignorant retail_admin → un admin revenant via cookie perdait son rôle admin.
               // Bug #5 : rôle interne explicite ('internal'). Aligné sur le flux de login.
               const serverRole = prefs.retail_admin === true ? 'admin' : prefs.user_type === 'client' ? 'client' : prefs.user_type === 'internal' ? 'internal' : null
               usePrefStore.getState().setServerRetailRole(serverRole)
               usePrefStore.getState().setIsRetailManager(prefs.retail_manager === true)
               usePrefStore.getState().setSupervisedN1(toSupervisedArray(prefs.supervised_n1))
               usePrefStore.getState().setSupervisedN2(toSupervisedArray(prefs.supervised_n2))
               usePrefStore.getState().setAbsence(prefs.absence_from ?? null, prefs.absence_to ?? null)
               // messika-pwa#34 : canal voulu relu au démarrage. En impersonation, c'est celui de l'OPÉRATEUR
               // (mémorisé au login) qui compte : jamais les prefs de la cible.
               if (!usePrefStore.getState().impersonateOperator) usePrefStore.getState().setPwaCanal(channelFromPref(prefs.pwa_canal))
               // Marque les prefs comme chargées : à partir de maintenant les écrans
               // peuvent se fier à serverRetailRole / isRetailManager pour la visibilité.
               usePrefStore.getState().setPrefsLoaded(true)
            } catch (e) {
               console.warn('getPrefs session restore KO (mode dégradé)', e)
            }
            // setAppWriteInitDone(true)
            console.log('setIsLogged(true)');
            setIsLogged(true)
            // messika-pwa#34 : bascule de canal / nouvelle version au démarrage (overlay + rechargement)
            void runUpdateCheckpoint()
         }).catch(err => {
            if (err?.code === 401) {
               console.log('Account pas OK', err);
               // setAppWriteInitDone(false)
               console.log('setIsLogged(false)');
               setIsLogged(false)
               void runUpdateCheckpoint(false)   // messika-pwa#39 : pas de session, pref inconnue → pas de bascule
            } else {
               // setAppWriteInitDone(true)
               console.log('Account pas OK mais erreur inconnue... sans doute offline!', JSON.stringify(err));
            }
         })
       })
      }
      return () => { cancelled = true }
   }, [appWriteEndpoint, appWriteProjectId, setIsLogged, setIsGrandUtilisateur])

   /*
   ██       ██████   ██████  ██ ███    ██
   ██      ██    ██ ██       ██ ████   ██
   ██      ██    ██ ██   ███ ██ ██ ██  ██
   ██      ██    ██ ██    ██ ██ ██  ██ ██
   ███████  ██████   ██████  ██ ██   ████
   */

   const doLogin = useCallback(async (login, pwd) => {
      if (account) {
         try {
            // On attend la fin de l'hydration Zustand (lecture IndexedDB ref_m3)
            // AVANT de toucher au store : sinon l'hydration tardive écrase nos sets
            // (race observée au 1er login : serverRetailRole='client' réécrit par null).
            await awaitPrefsHydrated()
            // Une session Appwrite peut être ENCORE active (cookie d'une connexion précédente
            // toujours valide → account.get() réussit au montage). Dans ce cas createEmailSession
            // échoue en 401 'user_session_already_exists'. On purge alors la/les session(s)
            // résiduelle(s) puis on recrée avec les identifiants saisis (= re-validation du mdp).
            // Impersonation : l'en-tête est retiré AVANT toute opération de session (createEmailSession /
            // deleteSessions), sinon on toucherait aux sessions de la CIBLE. Il est reposé après la session.
            const impTarget = usePrefStore.getState().impersonateTarget
            if (impTarget) setImpersonationHeader(client, null)
            let ret
            try {
               ret = await account.createEmailSession(login, pwd)
            } catch (e: any) {
               if (e?.type === 'user_session_already_exists') {
                  try { await account.deleteSessions() } catch { /* pas de session à supprimer */ }
                  ret = await account.createEmailSession(login, pwd)
               } else {
                  throw e
               }
            }
            if (impTarget) {
               // messika-pwa#34 : canal PWA de l'OPÉRATEUR, lu dans SES prefs (en-tête retiré) et mémorisé.
               try {
                  const opPrefs = ((await account.getPrefs()) ?? {}) as any
                  usePrefStore.getState().setPwaCanal(channelFromPref(opPrefs.pwa_canal))
               } catch (e) { console.warn('Prefs opérateur illisibles (canal PWA conservé)', e) }
               // En-tête posé avant toute autre requête (dont getPrefs), puis vérification.
               setImpersonationHeader(client, impTarget)
               let verified = false
               let accResult: any = null
               let accError: any = null
               try {
                  accResult = await account.get()
                  verified = isImpersonationVerified(accResult, impTarget, ret?.userId)
               } catch (e: any) {
                  accError = e
                  console.error('Impersonation : account.get() a échoué', e)
               }
               if (!verified) {
                  // Refus : en-tête retiré PUIS session supprimée (invariant : jamais deleteSessions en-tête posé).
                  setImpersonationHeader(client, null)
                  try { await account.deleteSessions() } catch { /* noop */ }
                  // Les données locales appartiennent à la cible : purge totale + oubli de la cible (#16).
                  try { await purgeLocalData(PURGE_ALL) } catch (e) { console.error('Purge après refus d\'impersonation', e) }
                  usePrefStore.getState().setImpersonation(null, null)
                  return { status: false, data: { impersonationRefused: true, refusal: impersonationRefusal(accResult, ret?.userId, accError), login } }
               }
               usePrefStore.getState().setImpersonation(impTarget, login)
            }

            // Nom du user (auth AW) pour l'affichage debug. Best-effort, ne bloque pas le login.
            try {
               const acc = await account.get()
               setCurrentUserId(acc?.$id ?? null)
               usePrefStore.getState().setUserName(acc?.name ?? '')
            } catch { /* noop */ }

            // On lit les prefs via getPrefs() (source fiable), PAS via account.get().prefs.
            // Au tout 1er login d'un user fraîchement créé, getPrefs() peut revenir VIDE (lag de
            // propagation) → user_type absent → serverRole=null ("aucun") jusqu'au refresh.
            // On RETENTE quelques fois tant qu'on n'a ni user_type ni retail_admin.
            let prefs: any = {}
            for (let attempt = 1; attempt <= 4; attempt++) {
               prefs = ((await account.getPrefs()) ?? {}) as any
               if (prefs?.user_type || prefs?.retail_admin === true) break
               if (attempt < 4) await new Promise((r) => setTimeout(r, 400))
            }
            setIsGrandUtilisateur(prefs.grand_utilisateur === true)

            // Bug #5 : rôle interne EXPLICITE ('internal') au lieu de null par preuve négative.
            // Un user mal configuré (user_type absent) reste null → fail-closed côté catalogue.
            const serverRole = prefs.retail_admin === true
               ? 'admin'
               : prefs.user_type === 'client'
                  ? 'client'
                  : prefs.user_type === 'internal'
                     ? 'internal'
                     : null
            usePrefStore.getState().setServerRetailRole(serverRole)
            usePrefStore.getState().setIsRetailManager(prefs.retail_manager === true)
            usePrefStore.getState().setSupervisedN1(toSupervisedArray(prefs.supervised_n1))
            usePrefStore.getState().setSupervisedN2(toSupervisedArray(prefs.supervised_n2))
            usePrefStore.getState().setAbsence(prefs.absence_from ?? null, prefs.absence_to ?? null)
            // messika-pwa#34 : hors impersonation, canal voulu = pref de l'utilisateur
            if (!impTarget) usePrefStore.getState().setPwaCanal(channelFromPref(prefs.pwa_canal))
            // Marque les prefs comme chargées : à partir de maintenant les écrans
            // peuvent se fier à serverRetailRole / isRetailManager pour la visibilité.
            usePrefStore.getState().setPrefsLoaded(true)

            // Forçage de re-sync posé par l'admin (dashboard) dans les prefs : remonté au
            // flux de login pour écraser les last_updated_* (cf. Login.startFetches), puis
            // consommé via awConsumeForcedSync().
            return { status: true, data: ret, forcedLastSync: prefs?.forced_last_sync ?? null }
         } catch (err) {  // Failure
            console.log('Do login ERR', err)
            // setIsLogged(false)
            // setAppWriteDatabaseId(null)
            // setAppWriteProjectId(null)
            return { status: false, data: err }
         }
      } else {
         console.log('Do login ERR : account est null')
         return { status: false, data: null }
      }
   }, [account, setIsGrandUtilisateur])

   /**
    * Pose / efface la période d'absence dans user.prefs (AppWrite).
    * Lit les prefs courants pour les conserver, modifie absence_from/to (ou supprime),
    * et met à jour le store local. from/to vides ou null = effacer la période.
    */
   const setUserAbsence = useCallback(async (from: string | null, to: string | null) => {
      if (!account) return { ok: false, err: 'no account' }
      try {
         const cur = await account.getPrefs()
         const next: any = { ...cur }
         if (from && to) {
            next.absence_from = from
            next.absence_to = to
         } else {
            delete next.absence_from
            delete next.absence_to
         }
         await account.updatePrefs(next)
         usePrefStore.getState().setAbsence(from || null, to || null)
         return { ok: true }
      } catch (err) {
         console.error('setUserAbsence failed', err)
         return { ok: false, err }
      }
   }, [account])

   const doLogout = useCallback(async (mode: LogoutMode = 'logout') => {
      console.log('setIsLogged(false)');
      setIsLogged(false)   // Peu importe, on considère que c'est logged out...
      setCurTimeout(null)  // Idem pour le timer de session
      usePrefStore.getState().setPrefsLoaded(false)   // Les prefs en mémoire ne sont plus celles d'un user loggué.
      if (account) {
         try {
            // Séquence de sortie (impersonation : en-tête retiré AVANT la suppression de session,
            // sinon ce sont les sessions de la cible qui seraient supprimées).
            for (const step of logoutSequence(isImpersonating(), mode)) {
               if (step === 'removeHeader') setImpersonationHeader(client, null)
               else if (step === 'deleteSessions') await account.deleteSessions()
               else if (step === 'forgetOperator') usePrefStore.getState().setImpersonation(usePrefStore.getState().impersonateTarget, null)   // cible conservée (#16)
               else if (step === 'purgeDb') await purgeLocalData(PURGE_ALL)
               else if (step === 'forgetImpersonation') usePrefStore.getState().setImpersonation(null, null)
            }
            console.log('Do logout OK', account)
            return true
         }
         catch (err) {  // Failure
            console.log('Do logout ERR', err)
            return false
         }
      } else {
         return true
      }
   }, [account, client, setCurTimeout, setIsLogged])

   const awPushUdid = useCallback((login) => {
      console.log('awPushUdid');
      if (isImpersonating()) return Promise.resolve()   // impersonation : ne pas rattacher l'appareil à la cible
      return new Promise<void>(async (resolve, reject) => {
         if (db && client) {
            const obj = {
               login: login,
               version: getVersion(),
               last_seen: moment().toISOString(),
               user_agent: JSON.stringify({ user_agent: navigator.userAgent, standalone: (window.matchMedia('(display-mode: standalone)').matches || (navigator as any).standalone) ? 'YES' : 'NO' }),
            }
            const id = usePrefStore.getState().udid   // lecture fraîche (peut avoir été régénéré par awEnsureUniqueUdidPrefix)
            try {
               // console.log(`createDocument()`, obj, id);
               let meId: string | undefined
               try { meId = (await account.get())?.$id } catch { /* pas de session : permissions par défaut */ }
               await db.createDocument(appWriteDatabaseId, appWriteCollUdidId, id, obj, userOwnPermissions(meId))
            } catch (err) {
               if (err.code === 409) { // Already exists
                  // console.log(`updateDocument()`, obj);
                  try {
                     await db.updateDocument(appWriteDatabaseId, appWriteCollUdidId, id, obj)
                  } catch (err) {
                     console.error('UpdateDocument - CATCH ERR', err)
                  }
                  resolve()
               } else {
                  console.error('CreateDocument - CATCH ERR', err)
                  reject(new Error(err))
               }
            }
         } else {
            reject(new Error('Pas de connection DB'))
         }
      })
   }, [account, appWriteCollUdidId, appWriteDatabaseId, client, db, getVersion, udid])

   const fetchOtp = useCallback(async () => {
      if (db) {
         try {
            const docs = await db.listDocuments(appWriteDatabaseId, appWriteCollOtpId)

            console.log('getOtp OK', docs)
            if (docs.documents.length > 0) {
               setOtp(docs.documents[0])
               console.log(docs.documents[0]);
            } else {
               setOtp(null)
            }
         } catch (err) {
            console.log('getTOTP ERR', err)
            setOtp(null)
         }
      } else {
         setOtp(null)
      }
   }, [appWriteCollOtpId, appWriteDatabaseId, db])

   const verifOtp = useCallback(async (token) => {
      let ret = false
      try {
         console.log('login', login);
         await axios.get(`${pwaApiEndpoint}/otp/${login}/check`, {
            params: {
               token
            },
         })
         console.log('Verif OTP OK')
         ret = true
      } catch (err) {
         console.log('Verif OTP NOK')
      }
      return ret
   }, [pwaApiEndpoint, login])

   const resetPasswordOtp = useCallback(async (token, password) => {
      let ret = false
      try {
         await axios.post(`${pwaApiEndpoint}/otp/${login}/reset_password`, {}, {
            params: {
               token,
               password
            },
         })
         console.log('Reset password OTP OK')
         ret = true
      } catch (err) {
         console.log('Reset password OTP NOK')
      }
      return ret
   }, [pwaApiEndpoint, login])

   // Reset par PIN envoyé par mail (alternative à l'OTP TOTP). Cf. webhooks /pin/:login/...
   // Envoi du PIN : réponse toujours générique (anti-énumération) → on ne remonte pas d'info sensible.
   const sendResetPin = useCallback(async (loginArg: string) => {
      try {
         await axios.post(`${pwaApiEndpoint}/pin/${encodeURIComponent(loginArg)}/send`)
         console.log('Send reset PIN OK')
         return true
      } catch (err) {
         console.log('Send reset PIN NOK')
         return false
      }
   }, [pwaApiEndpoint])

   const resetPasswordPin = useCallback(async (loginArg: string, pin: string, password: string) => {
      let ret = false
      try {
         await axios.post(`${pwaApiEndpoint}/pin/${encodeURIComponent(loginArg)}/reset_password`, { pin, password })
         console.log('Reset password PIN OK')
         ret = true
      } catch (err) {
         console.log('Reset password PIN NOK')
      }
      return ret
   }, [pwaApiEndpoint])

   /*
    ██████  ██████  ███    ███ ███    ███  ██████  ███    ██
   ██      ██    ██ ████  ████ ████  ████ ██    ██ ████   ██
   ██      ██    ██ ██ ████ ██ ██ ████ ██ ██    ██ ██ ██  ██
   ██      ██    ██ ██  ██  ██ ██  ██  ██ ██    ██ ██  ██ ██
    ██████  ██████  ██      ██ ██      ██  ██████  ██   ████
   */

   const findMostRecentUpdate = useCallback(async (table) => {
      const all_items = await dexie_db[table].toCollection().toArray()

      return all_items.reduce((prev, an_item) => {
         const utc = moment.utc(an_item.last_updated)
         // console.log(an_item.last_updated, utc, utc.toISOString());
         if (!prev || utc > prev) {
            return utc
         } else {
            return prev
         }
      }, null)
   }, [])

   /**
   * Récupération d'un document d'une collection (AppWrite) comme un "Tarif" ou une "Liste" (collections, familles, portes etc) à partir de son nom et du dernier checksum connu.
   * On récupère si checksum différent
   */
   const getCollectionItem = useCallback(async (coll_id, name, checksum) => {
      console.log('getCollectionItem', coll_id, name, checksum);
      if (db) {
         try {
            const docs = await db.listDocuments(appWriteDatabaseId, coll_id, [
               Query.equal('$id', name),
               Query.notEqual('checksum', checksum),
               // Query.limit(99999),
            ])

            if (docs.total === 0) {
               return { status: true, data: null }    // data = null indique qu'il n'y a pas de doc plus récent
            } else {
               return { status: true, data: docs.documents[0] }
            }
         } catch (err) {
            // Si err.code === 401 -> pas loggué
            // Sinon c'est peut-être un pb de connexion...
            return { status: false, data: err }
         }
      } else {
         return { status: false, data: null }
      }
   }, [appWriteDatabaseId, db])

   /*
   ███████ ████████  ██████   ██████ ██   ██ ███████
   ██         ██    ██    ██ ██      ██  ██  ██
   ███████    ██    ██    ██ ██      █████   ███████
        ██    ██    ██    ██ ██      ██  ██       ██
   ███████    ██     ██████   ██████ ██   ██ ███████
   */

   /*
      - J01 Messika group France 
      - U01 Messika USA 
      - H01 Messika HKG 
      - Y01 Messika Japon 
      - C01 Messika Chine 
   */

   const getStock = useCallback(async (model_id, depot) => {
      const doc_id = `${depot ?? glob_const.depot_defaut}-${model_id}`

      if (db) {
         try {
            const stocks = await db.getDocument(appWriteDatabaseId, appWriteCollStockId, doc_id)
            return { status: true, data: stocks.sku_stocks }
         } catch (err) {
            // Doc absent (404) = stock connu nul pour ce dépôt, pas une erreur réseau.
            // Tout autre code (401 pas loggué, network error, 500, ...) est une vraie erreur.
            const code = (err as { code?: number })?.code
            const notFound = code === 404
            if (!notFound) console.log('getStock ERR', err)
            return { status: false, notFound, data: err }
         }
      } else {
         return { status: false, notFound: false, data: null }
      }
   }, [appWriteCollStockId, appWriteDatabaseId, db])

   /*
   ██      ██ ███████ ████████ ███████
   ██      ██ ██         ██    ██
   ██      ██ ███████    ██    ███████
   ██      ██      ██    ██         ██
   ███████ ██ ███████    ██    ███████
   */

   // Fetch générique pour collections, couleurs, cycles, etapes, familles, genres, portes
   // `getCurrent` (optionnel) : renvoie la liste actuellement en store → sert au garde
   // anti-désync (checksum présent mais store vide → on re-fetch au lieu de garder le vide).
   const fetchList = useCallback((name, setList, checksum, setChecksum, getCurrent?) => {
      return new Promise<void>((resolve, reject) => {
         console.log(`Fetch ${name}`)

         // Re-fetch forcé en ignorant le checksum (1er chargement OU réparation d'une désync).
         const forceFetch = () => getCollectionItem(appWriteCollListsId, name, '').then(res2 => {
            if (res2.status && res2.data) {
               try {
                  setList(JSON.parse(res2.data.data))
                  setChecksum(res2.data.checksum)
                  console.log(`fetch ${name} > OK (re-fetch désync)`)
                  resolve()
               } catch (err) { reject(new Error(err)) }
            } else {
               console.log(`fetch ${name} > ERR (introuvable au re-fetch)`)
               reject(new Error(`${name}: Not found and no local data!`))
            }
         }).catch(() => reject(new Error('Erreur inconnue')))

         getCollectionItem(appWriteCollListsId, name, checksum ?? '').then(res => {
            if (res.status) {
               const doc = res.data

               if (doc) {  // On a fetché un doc plus récent
                  console.log(`fetch ${name} > OK`);
                  try { // Permet de s'assurer que le JSON est OK
                     setList(JSON.parse(doc.data))
                     setChecksum(doc.checksum)
                     resolve()
                  } catch (err) {
                     console.log(`fetch ${name} > ERR`, err);
                     reject(new Error(err))
                  }
               } else {    // On n'a pas fetché de doc, donc pas trouvé de plus récent
                  console.log(`fetch ${name} > Doc null`);
                  // Garde anti-désync : si un checksum existe mais que la liste locale est VIDE,
                  // le "à jour" est mensonger (données perdues) → on re-fetch en ignorant le checksum.
                  const cur = getCurrent ? getCurrent() : undefined
                  const isEmptyLocal = getCurrent
                     ? (cur == null || (typeof cur === 'object' && Object.keys(cur).length === 0))
                     : false
                  if (!checksum) {  // 1er appel déjà fait avec '' → doc réellement absent
                     console.log(`fetch ${name} > ERR`);
                     reject(new Error(`${name}: Not found and no local data!`))
                  } else if (isEmptyLocal) {  // checksum présent mais store vide = désync → re-fetch forcé
                     console.warn(`fetch ${name} > désync (checksum présent, store vide) → re-fetch forcé`)
                     forceFetch()
                  } else {    // On garde les data locales récupérées d'un fetch précédent
                     resolve()
                  }
               }
            } else {
               console.log(`fetch ${name} > ERR`, res);
               reject(new Error(res?.data?.message ?? 'Erreur inconnue'))
            }
         }).catch(err => {
            console.log(`fetch ${name} > ERR`, err);
            reject(new Error('Erreur inconnue'))
         })
      })
   }, [appWriteCollListsId, getCollectionItem])

   /*
    ██████ ██    ██ ███████ ████████  ██████  ███    ███ ███████ ██████  ███████
   ██      ██    ██ ██         ██    ██    ██ ████  ████ ██      ██   ██ ██
   ██      ██    ██ ███████    ██    ██    ██ ██ ████ ██ █████   ██████  ███████
   ██      ██    ██      ██    ██    ██    ██ ██  ██  ██ ██      ██   ██      ██
    ██████  ██████  ███████    ██     ██████  ██      ██ ███████ ██   ██ ███████
   */

   // ⚠️ Ajout/modif d'un champ mappé -> incrémenter LOCAL_DATA_VERSIONS.customers (cf. src/libs/localDataVersion.ts)
   const buildCustomerObject = (appWriteObject) => {
      // console.log(appWriteObject['$updatedAt'], moment.utc(appWriteObject['$updatedAt']), moment.utc(appWriteObject['$updatedAt']).toISOString());
      return {
         id: appWriteObject.number,
         name: appWriteObject.name,
         phones: appWriteObject.phones,
         email: appWriteObject.email,
         tarifs: JSON.parse(appWriteObject.tariffs),
         // agent: appWriteObject.agent,
         // representant: appWriteObject.representant,
         // responsable: appWriteObject.responsable,
         depot: appWriteObject.depot,
         depot_retail: appWriteObject.depot_retail ?? null,
         // groupe: appWriteObject.groupe,
         credit: appWriteObject.credit,
         factures_ouvertes: appWriteObject.factures_ouvertes,
         contacts: appWriteObject.contacts.reduce((prev, a_contact) => {
            const contact = JSON.parse(a_contact)
            return { ...prev, [contact.id]: contact }
         }, {}),
         addresses: appWriteObject.addresses.reduce((prev, an_address) => {
            const address = JSON.parse(an_address)
            return { ...prev, [address.id]: address }
         }, {}),
         groupe_client: appWriteObject.groupe_client ?? null,
         zone_geo: appWriteObject.zone_geo ?? null,
         exclu_boutique: appWriteObject.exclu_boutique ?? null,
         has_n1_supervisor: appWriteObject.has_n1_supervisor ?? null,
         shortname: appWriteObject.shortname ?? null,
         last_updated: moment.utc(appWriteObject['$updatedAt']).toISOString(),//format(),
      }
   }

   const addCustomer = useCallback(async (a_customer) => {
      let added = 0, updated = 0

      const res = await dexie_db.customers.get(a_customer.number);
      // console.log('>>>3', res);
      if (res === undefined) {
         // console.log('>>>4', buildCustomerObject(a_customer));
         await dexie_db.customers.add(buildCustomerObject(a_customer));
         added = 1
         // console.log(`Order ${an_order.id} added as ${id}`);
      } else {
         // console.log('>>>5', buildCustomerObject(a_customer));
         await dexie_db.customers.put(buildCustomerObject(a_customer));
         updated = 1
         // console.log(`Order ${an_order.id} updated`);
      }
      return { added, updated }
   }, [])

   // Ajoute un customer local qui n'existe pas dans AppWrite. Sert pour les devis par tarif
   const addFakeLocalCustomer = useCallback(async (a_fake_customer) => {
      const res = await dexie_db.customers.get(a_fake_customer.number);
      if (res === undefined) {
         await dexie_db.customers.add(buildCustomerObject(a_fake_customer));
      } else {
         await dexie_db.customers.put(buildCustomerObject(a_fake_customer));
      }
   }, [])

   const deleteCustomer = useCallback(async (an_id) => {
      try {
         await dexie_db.customers.delete(an_id);
      } catch (err) {
         console.log(`Pb delete customer ${an_id}`, err);
      }
   }, [])

   const fetchCustomers = useCallback((newLogin) => {
      return new Promise<void>(async (resolve, reject) => {
         let added = 0, updated = 0

         if (db && client) {
            try {
               const arr_queries = [
                  Query.limit(99999),
               ]
               const _last_updated_customers = useSalesStore.getState().last_updated_customers
               // Version locale périmée -> rechargement complet (cf. src/libs/localDataVersion.ts)
               const fullReload = newLogin || isLocalDataOutdated(useSalesStore.getState().local_data_versions?.customers, LOCAL_DATA_VERSIONS.customers)
               if (!fullReload && _last_updated_customers) {
                  let dt_ref = moment.utc(_last_updated_customers)

                  if (!dt_ref.isValid()) {
                     console.error(`last_updated_customers (${_last_updated_customers}) invalide.`)
                     dt_ref = moment.utc("2000-01-01")
                     console.error(`=> Fallback 2000-01-01. ${dt_ref}`)
                  }
                  arr_queries.push(Query.greaterThan('$updatedAt', dt_ref.toISOString()))
               }
               arr_queries.push(Query.orderAsc('$updatedAt'))
               console.log('last_updated_customers', _last_updated_customers);
               const docs = await db.listDocuments(appWriteDatabaseId, appWriteCollCustomersId, arr_queries)

               console.log('fetchCustomers', docs);
               if (docs.total === 0) {
                  useSalesStore.getState().setLocalDataVersion('customers', LOCAL_DATA_VERSIONS.customers)
                  resolve()
                  // return { status: true, data: null }    // data = null indique qu'il n'y a pas de doc plus récent
               } else {
                  // console.log('>>>1');
                  for (const a_customer of docs.documents) {
                     // console.log('>>>2');
                     const ret = await addCustomer(a_customer)
                     added += ret.added
                     updated += ret.updated
                     // console.log('>>>6');
                  }
                  // console.log('>>>7');
                  console.log(`fetchCustomers: added=${added}, updated=${updated}`);
                  useSalesStore.getState().setLocalDataVersion('customers', LOCAL_DATA_VERSIONS.customers)
                  resolve()
                  // return { status: true, data: null }
               }
            } catch (err) {
               // console.log('>>>8', err);
               // Si err.code === 401 -> pas loggué
               // Sinon c'est peut-être un pb de connexion...
               console.log('Erreur de format de données pour Customers !');
               reject(new Error(err))
               // return { status: false, data: err }
            }
         } else {
            // console.log('>>>9');
            reject(new Error('Pas de connection DB'))
            // return { status: false, data: null }
         }
      })
   }, [addCustomer, appWriteCollCustomersId, appWriteDatabaseId, client, db, last_updated_customers])

   const cleanCustomers = useCallback(() => {
      return new Promise<void>(async (resolve, reject) => {
         if (db && client) {
            try {
               const docs = await db.listDocuments(appWriteDatabaseId, appWriteCollCustomersId, [
                  Query.select(['number']),  // On n'a besoin que de l'ID pour purger
                  Query.limit(99999),
               ])

               console.log(`cleanCustomers : ${docs.documents.length} docs`)
               if (docs.total > 0) {
                  const keep_ids = docs.documents.reduce((prev, a_doc) => {
                     // console.log(a_doc);
                     return new Set([...prev, a_doc.number])
                  }, new Set())

                  console.log(`Keep ${keep_ids.size} ids`);

                  const all_customers = await dexie_db.customers.toCollection().toArray()

                  for (const a_customer of all_customers) {
                     const an_id = a_customer.id
                     // console.log(`Check ${an_id} `);
                     if (!an_id.startsWith(glob_const.prefix_prospect) && !keep_ids.has(an_id)) {
                        console.log(`Delete customer ${an_id}`)
                        deleteCustomer(an_id)
                        // } else {
                        //    console.log(`Garder customer ${an_id}`)
                     }
                  }
               }
               resolve()
            } catch (err) {
               // console.log('>>>8', err);
               // Si err.code === 401 -> pas loggué
               // Sinon c'est peut-être un pb de connexion...
               reject(new Error(err))
               // return { status: false, data: err }
            }
         } else {
            // console.log('>>>9');
            reject(new Error('Pas de connection DB'))
            // return { status: false, data: null }
         }
      })
   }, [appWriteCollCustomersId, appWriteDatabaseId, client, db, deleteCustomer])

   /*
    ██████  ██████  ██████  ███████ ██████  ███████
   ██    ██ ██   ██ ██   ██ ██      ██   ██ ██
   ██    ██ ██████  ██   ██ █████   ██████  ███████
   ██    ██ ██   ██ ██   ██ ██      ██   ██      ██
    ██████  ██   ██ ██████  ███████ ██   ██ ███████
   */

   // Sert à préparer un objet pour un 'add' ou un 'put' dans Dexie, depuis un objet AppWrite
   const _buildOrderObjectFromAppWriteObject = useCallback((is_bi, appWriteObject, readonly) => {
      // console.log(appWriteObject['$updatedAt'], moment.utc(appWriteObject['$updatedAt']), moment.utc(appWriteObject['$updatedAt']).toISOString());
      const obj = {
         /**
          * ATTENTION, ce modèle doit être compatible avec useSales.makeTemplate()
          */
         id: appWriteObject.id,
         customer_id: appWriteObject.cust_id,
         type: appWriteObject.type,
         date: moment(appWriteObject.date).format('YYYY-MM-DD'),
         time: moment(appWriteObject.date).format('HH:mm'),
         delivery: moment(appWriteObject.deliv_date).format('YYYY-MM-DD'),
         addresses: {
            jewels: appWriteObject.deliv_addr,
            ecrins: appWriteObject.ecrins_addr,
         },
         comment: appWriteObject.comment,
         mark: appWriteObject.mark,
         signature: appWriteObject.signature ? JSON.parse(appWriteObject.signature) : null,
         lines: appWriteObject.lines.map(a_line => {
            return JSON.parse(a_line)
         }),
         // synced: is_bi ? null : false,
         readonly: is_bi || readonly,
         ome_doc_id: appWriteObject.ome_doc_id,
         status: is_bi ? order_status.done_m3 : appWriteObject.status,
         last_pushed: null,      // Sert a ne pas refresh l'objet dans Dexie quand on push vers AppWrite et qu'on obtient un event en retour. S'il y a moins de {glob_const.min_delay_on_push} secondes (15), on ne refresh pas la BDD locale (Dexie)
         last_updated: moment.utc(appWriteObject['$updatedAt']).toISOString(),//format(),
      }
      if (is_bi) {
         return {
            currency: appWriteObject.currency,
            ...obj
         }
      } else {
         // short_udid: appWriteObject.short_udid,
         return {
            m3_number: appWriteObject.m3_number,
            ...(appWriteObject.origin_id ? { origin_id: appWriteObject.origin_id } : {}),
            ...(appWriteObject.original_lines?.length
               ? { original_lines: appWriteObject.original_lines.map(a_line => JSON.parse(a_line)) }
               : {}),
            // Champs retail (cf. WORKFLOW_BATCH.md). Tous nullables : on conserve null si null.
            retail_status_chg: appWriteObject.retail_status_chg ?? null,
            retail_warned: appWriteObject.retail_warned ?? null,
            ...obj
         }
      }
      // return obj
   }, [order_status])

   const buildOrderObjectFromAppWriteObject = useCallback((appWriteObject, readonly) => {
      return _buildOrderObjectFromAppWriteObject(false, appWriteObject, readonly)
   }, [_buildOrderObjectFromAppWriteObject])

   const buildBiOrderObject = useCallback((appWriteObject) => {
      return _buildOrderObjectFromAppWriteObject(true, appWriteObject, true)
   }, [_buildOrderObjectFromAppWriteObject])

   const _addOrder = useCallback(async (is_bi, an_order) => {
      let added = 0, updated = 0, res

      // console.log('_addOrder', is_bi, an_order);
      if (is_bi) {
         res = await dexie_db.bi_orders.get(an_order.id);
      } else {
         res = await dexie_db.orders.get(an_order.id);
      }
      if (res === undefined) {
         if (is_bi) {
            await dexie_db.bi_orders.add(buildBiOrderObject(an_order));
         } else {
            await dexie_db.orders.add(buildOrderObjectFromAppWriteObject(an_order, an_order.status !== order_status.new && an_order.status !== order_status.new_mgr));
         }
         added = 1
      } else {
         if (is_bi) {
            await dexie_db.bi_orders.put(buildBiOrderObject(an_order));
         } else {
            await dexie_db.orders.put(buildOrderObjectFromAppWriteObject(an_order, an_order.status !== order_status.new && an_order.status !== order_status.new_mgr));
         }
         updated = 1
      }
      return { added, updated }
   }, [buildBiOrderObject, buildOrderObjectFromAppWriteObject, order_status.new])

   const addOrder = useCallback((an_order) => {
      return _addOrder(false, an_order)
   }, [_addOrder])

   const _deleteLocalOrder = useCallback(async (is_bi, an_id) => {
      try {
         if (is_bi) {
            await dexie_db.bi_orders.delete(an_id);
         } else {
            await dexie_db.orders.delete(an_id);
         }
         return true
      } catch (err) {
         console.log(`Pb delete ${is_bi ? 'bi_' : ''}order ${an_id}`, err);
         return false
      }
   }, [])

   const deleteLocalOrder = useCallback(async (an_id) => {
      return await _deleteLocalOrder(false, an_id)
   }, [_deleteLocalOrder])

   /* Vraiment utile ? Pq voudrait-on supprimer une commande BI depuis l'appli ? */
   // const deleteBiOrder = useCallback(async (an_id) => {
   //    return await _deleteLocalOrder(true, an_id)
   // }, [_deleteLocalOrder])

   const awDeleteOrder = useCallback((id) => {
      console.log('awDeleteOrder');
      return new Promise<void>(async (resolve, reject) => {
         if (db && client) {
            try {
               await db.deleteDocument(appWriteDatabaseId, appWriteCollOrdersId, id)
               // await deleteLocalOrder(id)  // Tout s'est bien passé, on ne supprime de la base locale, ce sera fait par un retour d'événement (subscription)
               resolve()
            } catch (err) {
               console.error('deleteDocument - CATCH ERR', err)
               if (err.code === 404) {
                  await deleteLocalOrder(id)  // Document inconnu sur AW, on le supprime de la base locale car on n'aura pas de retour d'événement (subscription)
                  resolve() // On considère que tout s'est finalement bien passé
               } else {
                  reject(new Error('Pb suppression doc'))
               }
            }
         } else {
            reject(new Error('Pas de connection DB'))
         }
      })
   }, [appWriteCollOrdersId, appWriteDatabaseId, client, db, deleteLocalOrder])

   // Construction + bulkPut d'un bloc de documents AW dans dexie_db.orders (partagé _fetchOrders / _cleanOrders)
   const putOrderDocs = useCallback(async (docs) => {
      await dexie_db.orders.bulkPut(docs.map(an_order => buildOrderObjectFromAppWriteObject(an_order, an_order.status !== order_status.new && an_order.status !== order_status.new_mgr)))
   }, [buildOrderObjectFromAppWriteObject, order_status.new, order_status.new_mgr])

   const _fetchOrders = useCallback((newLogin, is_bi, fetchSubProgress) => {
      return new Promise<void>(async (resolve, reject) => {
         const perf = startPerfSession(`fetch${is_bi ? 'Bi' : ''}Orders`)
         let total_fetched = 0

         // console.log('QUERY', Query.limit(QUERY_PAGE_SIZE), Query.offset(10), Query.greaterThan('$updatedAt', moment.utc(last_updated_bi_orders).toISOString()));

         const _last_updated_bi_orders = useSalesStore.getState().last_updated_bi_orders
         const _last_updated_orders = useSalesStore.getState().last_updated_orders
         console.log('LAST BI', _last_updated_bi_orders, newLogin)

         if (db && client) {
            try {
               const arr_queries = []
               if (!newLogin) {
                  if (is_bi && _last_updated_bi_orders) {
                     let dt_ref = moment.utc(_last_updated_bi_orders)

                     if (!dt_ref.isValid()) {
                        console.error(`last_updated_bi_orders (${_last_updated_bi_orders}) invalide.`)
                        dt_ref = moment.utc("2000-01-01")
                        console.error(`=> Fallback 2000-01-01. ${dt_ref}`)
                     }

                     arr_queries.push(Query.greaterThan('$updatedAt', dt_ref.toISOString()))
                     console.log('last_updated_bi_orders', _last_updated_bi_orders);
                  } else if (!is_bi && _last_updated_orders) {
                     let dt_ref = moment.utc(_last_updated_orders)

                     if (!dt_ref.isValid()) {
                        console.error(`last_updated_orders (${_last_updated_orders}) invalide.`)
                        dt_ref = moment.utc("2000-01-01")
                        console.error(`=> Fallback 2000-01-01. ${dt_ref}`)
                     }

                     arr_queries.push(Query.greaterThan('$updatedAt', dt_ref.toISOString()))
                     console.log('last_updated_orders', _last_updated_orders);
                  }
               }
               // Grand utilisateur : ne pas récupérer les commandes retail (ECR/ECF) — c'est lui
               // qui a le plus gros volume. Placé hors du bloc delta → s'applique au login ET au
               // delta. notEqual multi-valeurs est rejeté par AppWrite → deux notEqual (AND).
               arr_queries.push(...buildOrderTypeFilterQueries(is_bi))
               // Rétention au PULL : ne pas récupérer les commandes BI dont la date de commande
               // (date métier, champ 'date' — PAS $updatedAt) est plus ancienne que la fenêtre
               // BI_RETENTION_MONTHS. Évite de fetcher des commandes qui seraient purgées juste
               // après par cleanBiOrders (réimport de vieilles ventes = $updatedAt récent mais
               // date ancienne). Même champ/format ISO que le prune serveur. Hors bloc delta →
               // s'applique au login ET au delta.
               if (is_bi) {
                  const biCutoffISO = moment().subtract(BI_RETENTION_MONTHS, 'months').startOf('day').toISOString()
                  arr_queries.push(Query.greaterThanEqual('date', biCutoffISO))
               }
               arr_queries.push(Query.orderAsc('$updatedAt'))

               // Pas de comptage : la progression affiche juste "N récupérées…" qui monte, sans %.
               // On ne peut pas connaître le total côté AW à coût raisonnable (docs.total plafonné
               // à la valeur de Query.limit), et le scan offset qu'on faisait avant coûtait 30 à 40 %
               // du temps total de sync — non rentable vs un simple chiffre croissant.
               fetchSubProgress(trans("?Vérification des commandes"))

               // Pool de N workers parallèles. Chacun récupère un offset depuis `nextOffset`
               // (incrément atomique côté JS car synchrone entre awaits), fetch son bloc, écrit
               // dans Dexie, puis reprend un nouvel offset — jusqu'à ce qu'un bloc revienne vide
               // ou < QUERY_PAGE_SIZE, ce qui signale la fin.
               const FETCH_CONCURRENCY = 4
               let nextOffset = 0
               let foundEnd = false

               const runWorker = async (workerIdx: number) => {
                  while (!foundEnd) {
                     const myOffset = nextOffset
                     nextOffset += QUERY_PAGE_SIZE

                     let myDocs
                     let max_retry = MAX_FETCH_RETRIES
                     while (max_retry > 0) {
                        try {
                           myDocs = await perf.time('fetch_bloc (listDocuments full)', () => db.listDocuments(appWriteDatabaseId, is_bi ? appWriteCollBiOrdersId : appWriteCollOrdersId, [
                              ...arr_queries,
                              Query.limit(QUERY_PAGE_SIZE),
                              Query.offset(myOffset),
                           ]))
                           perf.addBytes('fetch_bloc (listDocuments full)', roughJsonSize(myDocs.documents))
                           max_retry = 0
                        } catch (err) {
                           console.log(`***5 (worker ${workerIdx} offset=${myOffset})`, err)
                           await new Promise(resolve => setTimeout(resolve, RETRY_PAUSE))
                           console.log('***6', 'Après pause')
                           if (--max_retry <= 0) throw err
                        }
                     }

                     console.log(`fetch${is_bi ? 'Bi' : ''}Orders: worker=${workerIdx} offset=${myOffset} ${myDocs.documents.length} docs`)
                     if (myDocs.documents.length === 0) {
                        foundEnd = true
                        return
                     }

                     // bulkPut du bloc
                     const _dexieT0 = performance.now()
                     if (is_bi) {
                        await dexie_db.bi_orders.bulkPut(myDocs.documents.map(an_order => buildBiOrderObject(an_order)))
                     } else {
                        await putOrderDocs(myDocs.documents)
                     }
                     total_fetched += myDocs.documents.length
                     perf.add('dexie_write_bloc (bulkPut)', performance.now() - _dexieT0)
                     perf.incr('docs_processed', myDocs.documents.length)

                     if (is_bi) {
                        fetchSubProgress(transWithParams("?hist_commandes", formatNumber(total_fetched), total_fetched))
                     }

                     // Bloc < PAGE_SIZE = dernier bloc (les autres workers en cours termineront leurs awaits,
                     // éventuellement sur des offsets plus hauts qui renverront 0 doc)
                     if (myDocs.documents.length < QUERY_PAGE_SIZE) {
                        foundEnd = true
                        return
                     }
                  }
               }

               await Promise.all(Array.from({ length: FETCH_CONCURRENCY }, (_, i) => runWorker(i)))
               perf.end()
               resolve()
            } catch (err) {
               console.log(`Erreur de format de données (total_fetched=${total_fetched}) pour ${is_bi ? 'Bi' : ''}Orders !`);
               perf.end()
               reject(new Error(err))
            }
         } else {
            reject(new Error('Pas de connection DB'))
         }
      })
   }, [last_updated_bi_orders, db, client, trans, appWriteDatabaseId, appWriteCollBiOrdersId, appWriteCollOrdersId, last_updated_orders, transWithParams, formatNumber, buildBiOrderObject, putOrderDocs])

   const fetchOrders = useCallback((newLogin, fetchSubProgress) => {
      return _fetchOrders(newLogin, false, fetchSubProgress)
   }, [_fetchOrders])

   const fetchBiOrders = useCallback((newLogin, fetchSubProgress) => {
      return _fetchOrders(newLogin, true, fetchSubProgress)
   }, [_fetchOrders])

   // IMPORTANT : le clean des Orders BI ne fait PAS comme les Orders (pas de diff avec AW).
   // Il PURGE localement les bi_orders hors fenêtre de rétention (date < BI_RETENTION_MONTHS)
   // + les ECR/ECF pour les grands utilisateurs. Appelé uniquement dans initialFetch (login).
   const _cleanOrders = useCallback((is_bi) => {
      return new Promise<void>(async (resolve, reject) => {
         if (db && client) {
            try {
               console.log(`${moment().unix()} : Avant query clean${is_bi ? 'Bi' : ''}Orders`)

               if (is_bi) {
                  // Purge par ancienneté : date stockée en 'YYYY-MM-DD' (indexée) → comparaison
                  // lexicographique = chronologique. Complément local du prune serveur.
                  const cutoff = moment().subtract(BI_RETENTION_MONTHS, 'months').format('YYYY-MM-DD')
                  const nbOld = await dexie_db.bi_orders.where('date').below(cutoff).delete()
                  console.log(`${moment().unix()} : Purge BiOrders date<${cutoff} : ${nbOld} supprimés`)
                  // Grand utilisateur : retirer aussi les ECR/ECF déjà en cache (le filtre au pull
                  // ne les enlève pas rétroactivement).
                  if (usePrefStore.getState().isGrandUtilisateur) {
                     const nbRetail = await dexie_db.bi_orders.where('type').anyOf(['ECR', 'ECF']).delete()
                     console.log(`${moment().unix()} : Purge BiOrders retail (GU) : ${nbRetail} supprimés`)
                  }
               } else {
                  // Fenêtres depuis la date du jour (cf. libs/orderLocalRetention.ts) : 3 mois (tout) + 36 mois (KOT/KTM)
                  const cutoffs = computeKeepCutoffs(new Date())
                  const typeFilter = buildOrderTypeFilterQueries(false)
                  // Liste paginée d'ids ; une page en échec (après reprises) fait échouer tout le clean :
                  // une liste partielle ferait purger des commandes valides.
                  const fetchRemoteIds = async (extra_queries) => {
                     const ids = new Set<string>()
                     let offset = 0
                     while (true) {
                        let page
                        let max_retry = MAX_FETCH_RETRIES
                        while (max_retry > 0) {
                           try {
                              page = await db.listDocuments(appWriteDatabaseId, appWriteCollOrdersId, [
                                 Query.select(['id']),  // On n'a besoin que de l'ID pour purger
                                 ...typeFilter,
                                 ...extra_queries,
                                 Query.orderAsc('$updatedAt'),
                                 Query.limit(QUERY_PAGE_SIZE),
                                 Query.offset(offset),
                              ])
                              max_retry = 0
                           } catch (err) {
                              console.log(`clean Orders : erreur page offset=${offset}`, err)
                              await new Promise(resolve => setTimeout(resolve, RETRY_PAUSE))
                              if (--max_retry <= 0) throw err
                           }
                        }
                        for (const a_doc of page.documents) ids.add(a_doc.id)
                        if (page.documents.length < QUERY_PAGE_SIZE) break
                        offset += QUERY_PAGE_SIZE
                     }
                     return ids
                  }

                  let general_ids, quota_ids
                  try {
                     general_ids = await fetchRemoteIds([Query.greaterThan('$updatedAt', cutoffs.general)])
                     quota_ids = await fetchRemoteIds([Query.equal('type', ['KOT', 'KTM']), Query.greaterThan('$updatedAt', cutoffs.quota)])
                  } catch (err) {
                     console.error('clean Orders : liste distante incomplète, rien n\'est supprimé ni rattrapé', err)
                     throw err
                  }
                  const remote_ids = new Set<string>([...general_ids, ...quota_ids])

                  const all_orders = await dexie_db.orders.toCollection().toArray()
                  const { toDelete, toDownload } = planOrderReconciliation(all_orders, remote_ids)
                  for (const an_id of toDelete) {
                     deleteLocalOrder(an_id)
                  }

                  // Rattrapage PAR IDS (jamais par $updatedAt : c'est ce critère qui les a fait manquer)
                  let nb_caught_up = 0
                  try {
                     for (let i = 0; i < toDownload.length; i += 100) {
                        const chunk = toDownload.slice(i, i + 100)
                        let docs
                        let max_retry = MAX_FETCH_RETRIES
                        while (max_retry > 0) {
                           try {
                              docs = await db.listDocuments(appWriteDatabaseId, appWriteCollOrdersId, [
                                 Query.equal('id', chunk),
                                 Query.limit(100),
                              ])
                              max_retry = 0
                           } catch (err) {
                              await new Promise(resolve => setTimeout(resolve, RETRY_PAUSE))
                              if (--max_retry <= 0) throw err
                           }
                        }
                        await putOrderDocs(docs.documents)
                        nb_caught_up += docs.documents.length
                     }
                  } catch (err) {
                     console.error('clean Orders : échec du rattrapage', err)
                  }
                  console.log(`clean Orders : ids distants ${general_ids.size} (général) / ${quota_ids.size} (quotas), ${toDelete.length} suppressions locales, ${toDownload.length} à rattraper, ${nb_caught_up} rattrapés`)
               }
               resolve()
            } catch (err) {
               reject(new Error(err))
            }
         } else {
            reject(new Error('Pas de connection DB'))
         }
      })
   }, [appWriteCollOrdersId, appWriteDatabaseId, client, db, deleteLocalOrder, putOrderDocs])

   const cleanOrders = useCallback(() => {
      return _cleanOrders(false)
   }, [_cleanOrders])

   const cleanBiOrders = useCallback(() => {
      return _cleanOrders(true)
   }, [_cleanOrders])

   // Push une commande locale. Les commandes BI ne sont pas concernées, évidemment...
   const awPushOrder = useCallback((id, opts: { failOnConflict?: boolean } = {}) => {
      // console.log('awPushOrder');
      return new Promise<boolean>(async (resolve, reject) => {
         if (db && client) {
            try {
               const doc = await getOrderById(id)
               const obj = {
                  id,
                  // short_udid: doc.short_udid,
                  type: doc.type,
                  cust_id: doc.customer_id,
                  date: doc.date,
                  deliv_date: doc.delivery,
                  comment: doc.comment,
                  mark: doc.mark,
                  signature: doc.signature ? JSON.stringify(doc.signature) : null,
                  // ECR/ECF : pas d'adresse jewels, seule l'adresse ecrins est utilisée (livraison écrins)
                  deliv_addr: (doc.type === type_order.retail_interne || doc.type === type_order.retail_externe) ? null : doc.addresses.jewels,
                  ecrins_addr: doc.addresses.ecrins,
                  lines: doc.lines.map(a_line => JSON.stringify(a_line)),
                  original_lines: doc.original_lines?.map(a_line => JSON.stringify(a_line)) ?? null,
                  status: (doc.status === order_status.locked4sync) ? order_status.locked : doc.status,
                  origin_id: doc.origin_id ?? null,
                  // Champs retail (cf. WORKFLOW_BATCH.md). Préserve les valeurs locales.
                  // retail_n*_user_id retirés (option B : la source d'autorité est maintenant
                  // customer.has_n1_supervisor + perms Appwrite posées par le batch).
                  retail_status_chg: doc.retail_status_chg ?? null,
                  retail_warned: doc.retail_warned ?? null,
               }
               // console.log(`getOrderById(${id})`, doc);
               // console.log('Update last pushed:', id, { last_pushed: moment().toISOString() });
               // await dexie_db.orders.update(id, { last_pushed: moment().toISOString() });
               await updateOrderLocally(id, { last_pushed: moment().toISOString() })

               // Diagnostic préventif : avant chaque push, vérifier que la session AW
               // est valide (account.get() doit retourner le user). Si KO → on logue
               // explicitement avant de tenter le createDocument (qui sortirait 401
               // sans indiquer la cause).
               let meId: string | undefined
               try {
                  const me = await account.get()
                  meId = me?.$id
                  console.log(`[awPushOrder] session OK — user: ${me?.$id} (${me?.email}), order: ${id}`)
               } catch (authErr) {
                  console.error(`[awPushOrder] SESSION INVALIDE avant push order ${id} :`, authErr)
                  // On continue quand même : si c'est juste une racine en debug, ça peut marcher.
               }

               // Log détaillé du payload envoyé (utile quand AW rejette pour "format invalide")
               console.log(`[awPushOrder] obj envoyé à AW (order=${id}) :`, obj)
               console.log(`[awPushOrder] field lengths :`, Object.fromEntries(
                  Object.entries(obj).map(([k, v]) => [k, typeof v === 'string' ? `string(${v.length}) "${v}"` : Array.isArray(v) ? `array(${v.length})` : v === null ? 'null' : typeof v])
               ))

               let pushOk = true
               try {
                  // console.log(`createDocument()`, obj);
                  await db.createDocument(appWriteDatabaseId, appWriteCollOrdersId, id, obj, userOwnPermissions(meId))
                  await updateOrderLocally(id, { status: obj.status })  // Tout s'est bien passé, on remplace le status local qui a peut-être été envoyé en "locked" vers AppWrite (cas où il était encore locaen locked4sync, voir qq lignes plus haut)
               } catch (err) {
                  if (err.code === 409) { // Already exists
                     // Création d'un NOUVEL order (failOnConflict) : un 409 = collision d'ID sur AW
                     // (doc déjà présent, potentiellement pas à nous). On NE tente PAS updateDocument
                     // (→ 401 si pas notre doc) : on remonte le conflit pour que l'appelant régénère un ID.
                     if (opts.failOnConflict) {
                        const e: any = new Error('AW_ID_CONFLICT'); e.awIdConflict = true
                        reject(e); return
                     }
                     // console.log(`updateDocument()`, obj);
                     try {
                        await db.updateDocument(appWriteDatabaseId, appWriteCollOrdersId, id, obj)
                        await updateOrderLocally(id, { status: obj.status })  // Tout s'est bien passé, on remplace le status local qui a peut-être été envoyé en "locked" vers AppWrite (cas où il était encore locaen locked4sync, voir qq lignes plus haut)
                     } catch (err) {
                        console.error(`[awPushOrder] updateDocument FAIL order=${id} status=${obj.status} code=${err?.code} type=${err?.type} msg=${err?.message}`)
                        console.error('[awPushOrder] full err :', err)
                        // Échec d'enregistrement AW (droits/perms ou réseau) → signalé à l'appelant via pushOk (toast côté caller).
                        pushOk = false
                        // await dexie_db.orders.update(id, { last_pushed: null });
                        await updateOrderLocally(id, { last_pushed: null })
                     }
                  } else {
                     console.error(`[awPushOrder] createDocument FAIL order=${id} status=${obj.status} code=${err?.code} type=${err?.type} msg=${err?.message}`)
                     console.error('[awPushOrder] full err :', err)
                     if (err?.code === 401) {
                        console.error('[awPushOrder] → 401 = soit session perdue (cf. log session ci-dessus), soit permissions COLLECTION orders ne permettent pas Create pour ce user.')
                     }
                     if (err?.code === 400 && err?.type === 'document_invalid_structure') {
                        console.error('[awPushOrder] → 400 document_invalid_structure : compare obj envoyé ci-dessus avec le schéma AW (types, sizes, enum values). Erreur AW :', err?.message)
                     }
                     // Échec d'enregistrement AW (droits/perms ou réseau) → signalé à l'appelant via pushOk (toast côté caller).
                     pushOk = false
                     // await dexie_db.orders.update(id, { last_pushed: null });
                     await updateOrderLocally(id, { last_pushed: null })
                  }
               }
               resolve(pushOk)
            } catch (err) {
               reject(new Error(err))
            }
         } else {
            reject(new Error('Pas de connection DB'))
         }
      })
   }, [appWriteCollOrdersId, appWriteDatabaseId, account, client, db, getOrderById, order_status, type_order, updateOrderLocally])

   /**
    * Renvoie les commandes qui sont restées non syncho (push vers M3 ou deleted)
    */
   const awPushWaitingOrders = useCallback(async () => {
      // console.log('awPushWaitingOrders');
      const arr = await dexie_db.orders.where('status').anyOf([order_status.locked4sync, order_status.deleted]).toArray()

      console.log('awPushWaitingOrders', arr);
      // messika-pwa#34 : on attend la fin des envois (le login ne bascule de canal qu'ensuite). Erreurs ignorées, comme avant.
      const pending: Promise<unknown>[] = []
      for (const an_order of arr) {
         console.log('ICI', an_order);
         if (an_order.status === order_status.locked4sync) {
            pending.push(awPushOrder(an_order.id).catch(() => { /* noop */ }))
         } else if (an_order.status === order_status.deleted) {
            pending.push(awDeleteOrder(an_order.id).catch(() => { /* noop */ }))
         }
      }
      await Promise.allSettled(pending)
      // console.log('LA');
   }, [awDeleteOrder, order_status.deleted, order_status.locked4sync, awPushOrder])

   /**
    * POST authentifié vers le webhook avec un JWT Appwrite court (cf. webhookClient.ts).
    */
   const postWebhookWithJwt = useCallback(
      (path: string, body: object = {}) => {
         // Impersonation : JWT de l'opérateur (client dédié) + email de la cible en en-tête.
         const imp = usePrefStore.getState()
         const target = imp.impersonateOperator ? imp.impersonateTarget : null
         return postWebhookWithJwtHelper(target ? jwtAccount : account, pwaApiEndpoint, path, body, target)
      },
      [account, jwtAccount, pwaApiEndpoint],
   )

   // Consomme (supprime côté serveur) le forçage de re-sync `forced_last_sync` de l'user
   // courant, une fois appliqué au login. Best-effort : un échec ne bloque pas le login
   // (au pire le forçage se ré-appliquera au prochain login).
   const awConsumeForcedSync = useCallback(async () => {
      if (isImpersonating()) return   // appliqué localement, jamais consommé (forçage de la cible)
      try {
         await postWebhookWithJwt('/consume-forced-sync')
      } catch (e) {
         console.warn('awConsumeForcedSync KO (non bloquant)', (e as any)?.message ?? e)
      }
   }, [postWebhookWithJwt])

   // Au 1er login (online) : garantit que le préfixe 4-car de l'udid n'est pas déjà porté par un
   // AUTRE device (sinon collisions d'ID de commande `<prefix>-<n>`). Régénère l'udid si besoin.
   // Best-effort : si le webhook est injoignable, on n'empêche pas le login (le retry-409 à la
   // création reste le filet). Ne tourne qu'une fois (flag udidPrefixChecked).
   const awEnsureUniqueUdidPrefix = useCallback(async () => {
      if (isImpersonating()) return   // JWT impossible en impersonation
      if (usePrefStore.getState().udidPrefixChecked) return
      for (let attempts = 0; attempts < 25; attempts++) {
         const current = usePrefStore.getState().udid
         let data: any
         try {
            const res = await postWebhookWithJwt('/udid/check-prefix', { udid: current })
            data = res?.data
         } catch (e) {
            console.warn('[udid] check-prefix indisponible → on garde l’udid (retry-409 en filet)', e)
            return
         }
         if (data?.thisExists || !data?.prefixTakenByOther) {
            usePrefStore.getState().setUdidPrefixChecked(true)
            return
         }
         // Préfixe déjà pris par un autre device → régénérer l'udid et re-vérifier.
         console.log('[udid] préfixe déjà pris, régénération de l’udid')
         usePrefStore.getState().setUdid(uuidv4())
      }
      console.warn('[udid] aucun préfixe libre trouvé après 25 essais')
   }, [postWebhookWithJwt])

   /**
    * Appelle le webhook pour (re)poser les permissions correctes sur une commande.
    * Utilisé après la création d'un reliquat pour que le user-client puisse le voir.
    */
   const awFixOrderPermissions = useCallback(async (orderId: string) => {
      try {
         console.log('awFixOrderPermissions', orderId);
         await postWebhookWithJwt(`/orders/${orderId}/fix-permissions`)
         console.log('awFixOrderPermissions OK', orderId);
      } catch (err) {
         console.error('awFixOrderPermissions FAILED', orderId, err);
      }
   }, [postWebhookWithJwt])

   // Envoie un brouillon manager (status=new_mgr) au user-client :
   // le webhook pose atomiquement les perms du user-client (+ admins) et passe le
   // statut directement à 'new' (le manager perd sa visibilité). Plus de transit new2cli.
   // (L'identité de l'appelant est dérivée serveur-side du JWT, plus envoyée dans le body.)
   // Retourne true si l'opération a réussi, false sinon.
   const awSendOrderToClient = useCallback(async (orderId: string): Promise<boolean> => {
      try {
         console.log('awSendOrderToClient', orderId);
         await postWebhookWithJwt(`/orders/${orderId}/send-to-client`)
         console.log('awSendOrderToClient OK', orderId);
         return true
      } catch (err) {
         console.error('awSendOrderToClient FAILED', orderId, err);
         return false
      }
   }, [postWebhookWithJwt])

   // Transitions du workflow retail via les webhooks (la fonction serveur unique décide
   // le statut cible + pose les perms). Retournent le nouveau statut. En cas d'échec elles
   // LAISSENT REMONTER l'erreur (axios) pour que l'appelant (useSales) puisse distinguer un
   // échec "stale/accès perdu" (401/403/404/409) d'une erreur réseau, et réagir (toast + nettoyage).
   // Pré-requis : l'order doit être à jour côté AW (faire awPushOrder AVANT si modifs locales).
   const awSubmitOrder = useCallback(async (orderId: string): Promise<string | null> => {
      const res = await postWebhookWithJwt(`/orders/${orderId}/submit`)
      return (res?.data?.status as string) ?? null
   }, [postWebhookWithJwt])

   const awValidateN2 = useCallback(async (orderId: string, reliquatLines?: { sku: string, qty: number }[]): Promise<string | null> => {
      const res = await postWebhookWithJwt(`/orders/${orderId}/validate-n2`, reliquatLines?.length ? { reliquatLines } : {})
      return (res?.data?.status as string) ?? null
   }, [postWebhookWithJwt])

   const awValidateN1 = useCallback(async (orderId: string, reliquatLines?: { sku: string, qty: number }[]): Promise<string | null> => {
      const res = await postWebhookWithJwt(`/orders/${orderId}/validate-n1`, reliquatLines?.length ? { reliquatLines } : {})
      return (res?.data?.status as string) ?? null
   }, [postWebhookWithJwt])

   const awReturnToClient = useCallback(async (orderId: string): Promise<string | null> => {
      const res = await postWebhookWithJwt(`/orders/${orderId}/return-to-client`)
      return (res?.data?.status as string) ?? null
   }, [postWebhookWithJwt])

   // Resynchronise la copie LOCALE d'un order avec l'état serveur (anti-stale). Sert quand l'order
   // a évolué ailleurs et qu'on l'a raté (asymétrie Realtime : aucun event au RETRAIT de perms ;
   // ou transition manquée hors ligne). Retourne le statut serveur, ou null si l'order n'est plus
   // accessible (perms retirées / supprimé) → la copie locale est purgée.
   const awReconcileOrder = useCallback(async (id: string, opts: { afterFailedPush?: boolean } = {}): Promise<string | null> => {
      try {
         const doc = await db.getDocument(appWriteDatabaseId, appWriteCollOrdersId, id)
         await dexie_db.orders.put(buildOrderObjectFromAppWriteObject(doc, doc.status !== order_status.new && doc.status !== order_status.new_mgr))
         return doc.status as string
      } catch (err: any) {
         const code = err?.code ?? err?.response?.status
         const action = decideReconcileErrorAction(code, !!opts.afterFailedPush)
         if (action === 'keep') return null   // 404 après push échoué : jamais créée sur AW, on garde la copie locale
         if (action === 'purge') {
            try { await dexie_db.orders.delete(id) } catch { /* ignore */ }
            return null
         }
         throw err   // erreur infra/réseau : ne pas toucher au local
      }
   }, [db, appWriteDatabaseId, appWriteCollOrdersId, buildOrderObjectFromAppWriteObject, order_status.new])

   /*
   ██████  ███████ ███████ ████████ ███████      █████      ██      ██ ██    ██ ██████  ███████ ██████
   ██   ██ ██      ██         ██    ██          ██   ██     ██      ██ ██    ██ ██   ██ ██      ██   ██
   ██████  █████   ███████    ██    █████       ███████     ██      ██ ██    ██ ██████  █████   ██████
   ██   ██ ██           ██    ██    ██          ██   ██     ██      ██  ██  ██  ██   ██ ██      ██   ██
   ██   ██ ███████ ███████    ██    ███████     ██   ██     ███████ ██   ████   ██   ██ ███████ ██   ██
   */

   // Fetch Reste à Livrer Ventes
   const buildVentesRALObject = (appWriteObject) => {
      return {
         id: appWriteObject.cust_id,
         ral_euro: appWriteObject.valeur_backorder_euro,
         ral_dollar: appWriteObject.valeur_backorder_dollar,
         ral: appWriteObject.qte_backorder,
         qte: appWriteObject.qte,
         ca_euro: appWriteObject.ca_euro,
         ca_dollar: appWriteObject.ca_dollar,
         last_updated: moment.utc(appWriteObject['$updatedAt']).toISOString(),
      }
   }

   const addVentesRAL = useCallback(async (a_ral) => {
      let added = 0, updated = 0

      // console.log('addVentesRAL', a_ral)
      const res = await dexie_db.ventes_ral.get(a_ral.cust_id);
      if (res === undefined) {
         await dexie_db.ventes_ral.add(buildVentesRALObject(a_ral));
         added = 1
      } else {
         await dexie_db.ventes_ral.put(buildVentesRALObject(a_ral));
         updated = 1
      }
      return { added, updated }
   }, [])

   const deleteVentesRAL = useCallback(async (an_id) => {
      try {
         await dexie_db.ventes_ral.delete(an_id);
      } catch (err) {
         console.log(`Pb delete Ventes RAL ${an_id}`, err);
      }
   }, [])

   const fetchVentesRAL = useCallback((newLogin) => {
      return new Promise<void>(async (resolve, reject) => {
         let added = 0, updated = 0

         if (db && client) {
            try {
               const arr_queries = [
                  Query.limit(99999),
               ]
               const _last_updated_ventes_ral = useSalesStore.getState().last_updated_ventes_ral
               if (!newLogin && _last_updated_ventes_ral) {
                  let dt_ref = moment.utc(_last_updated_ventes_ral)

                  if (!dt_ref.isValid()) {
                     console.error(`last_updated_ventes_ral (${_last_updated_ventes_ral}) invalide.`)
                     dt_ref = moment.utc("2000-01-01")
                     console.error(`=> Fallback 2000-01-01. ${dt_ref}`)
                  }

                  arr_queries.push(Query.greaterThan('$updatedAt', dt_ref.toISOString()))
               }
               arr_queries.push(Query.orderAsc('$updatedAt'))
               console.log('last_updated_ventes_ral', _last_updated_ventes_ral);
               const docs = await db.listDocuments(appWriteDatabaseId, appWriteCollVentesRALId, arr_queries)

               // console.log('fetchVentesRAL', docs);
               if (docs.total === 0) {
                  resolve()
               } else {
                  for (const a_ral of docs.documents) {
                     const ret = await addVentesRAL(a_ral)
                     added += ret.added
                     updated += ret.updated
                  }
                  console.log(`fetchVentesRAL: added=${added}, updated=${updated}`);
                  resolve()
               }
            } catch (err) {
               // Si err.code === 401 -> pas loggué
               // Sinon c'est peut-être un pb de connexion...
               console.log('Erreur de format de données pour Ventes RAL !');
               reject(new Error(err))
            }
         } else {
            reject(new Error('Pas de connection DB'))
         }
      })
   }, [addVentesRAL, appWriteCollVentesRALId, appWriteDatabaseId, client, db, last_updated_ventes_ral])

   const cleanVentesRAL = useCallback(() => {
      return new Promise<void>(async (resolve, reject) => {
         if (db && client) {
            try {
               const docs = await db.listDocuments(appWriteDatabaseId, appWriteCollVentesRALId, [
                  Query.select(['cust_id']),  // On n'a besoin que de l'ID pour purger
                  Query.limit(99999),
               ])

               console.log(`cleanVentesRAL : ${docs.documents.length} docs`)
               // if (docs.total > 0) {
               const keep_ids = docs.documents.reduce((prev, a_doc) => {
                  // console.log(a_doc);
                  return new Set([...prev, a_doc.cust_id])
               }, new Set())

               console.log(`Keep ${keep_ids.size} Ventes RAL ids`);

               const all_customers = await dexie_db.ventes_ral.toCollection().toArray()

               for (const a_customer of all_customers) {
                  const an_id = a_customer.id
                  if (!keep_ids.has(an_id)) {
                     console.log(`Delete RAL for customer ${an_id}`)
                     deleteVentesRAL(an_id)
                  }
               }
               // }
               resolve()
            } catch (err) {
               // Si err.code === 401 -> pas loggué
               // Sinon c'est peut-être un pb de connexion...
               reject(new Error(err))
            }
         } else {
            reject(new Error('Pas de connection DB'))
         }
      })
   }, [appWriteCollVentesRALId, appWriteDatabaseId, client, db, deleteVentesRAL])

   /*
    ██████  ██████  ███    ██ ███████ ██ ███████ ███████
   ██      ██    ██ ████   ██ ██      ██ ██      ██
   ██      ██    ██ ██ ██  ██ █████   ██ █████   ███████
   ██      ██    ██ ██  ██ ██ ██      ██ ██           ██
    ██████  ██████  ██   ████ ██      ██ ███████ ███████
   */

   // Fetch Confies
   const buildConfiesObject = (appWriteObject) => {
      return {
         id: appWriteObject.cust_id,
         qte_site: appWriteObject.qte_site,
         ca_site_euro: appWriteObject.ca_site_euro,
         ca_site_dollar: appWriteObject.ca_site_dollar,
         last_updated: moment.utc(appWriteObject['$updatedAt']).toISOString(),
      }
   }

   const addConfies = useCallback(async (a_ral) => {
      let added = 0, updated = 0

      // console.log('addConfies', a_ral)
      const res = await dexie_db.confies.get(a_ral.cust_id);
      if (res === undefined) {
         await dexie_db.confies.add(buildConfiesObject(a_ral));
         added = 1
      } else {
         await dexie_db.confies.put(buildConfiesObject(a_ral));
         updated = 1
      }
      return { added, updated }
   }, [])

   const deleteConfies = useCallback(async (an_id) => {
      try {
         await dexie_db.confies.delete(an_id);
      } catch (err) {
         console.log(`Pb delete Confies RAL ${an_id}`, err);
      }
   }, [])

   const fetchConfies = useCallback((newLogin) => {
      return new Promise<void>(async (resolve, reject) => {
         let added = 0, updated = 0

         if (db && client) {
            try {
               const arr_queries = [
                  Query.limit(99999),
               ]
               const _last_updated_confies = useSalesStore.getState().last_updated_confies
               if (!newLogin && _last_updated_confies) {
                  let dt_ref = moment.utc(_last_updated_confies)

                  if (!dt_ref.isValid()) {
                     console.error(`last_updated_confies (${_last_updated_confies}) invalide.`)
                     dt_ref = moment.utc("2000-01-01")
                     console.error(`=> Fallback 2000-01-01. ${dt_ref}`)
                  }

                  arr_queries.push(Query.greaterThan('$updatedAt', dt_ref.toISOString()))
               }
               arr_queries.push(Query.orderAsc('$updatedAt'))
               console.log('last_updated_confies', _last_updated_confies);
               const docs = await db.listDocuments(appWriteDatabaseId, appWriteCollConfiesId, arr_queries)

               // console.log('fetchConfies', docs);
               if (docs.total === 0) {
                  resolve()
               } else {
                  for (const a_ral of docs.documents) {
                     const ret = await addConfies(a_ral)
                     added += ret.added
                     updated += ret.updated
                  }
                  console.log(`fetchConfies: added=${added}, updated=${updated}`);
                  resolve()
               }
            } catch (err) {
               // Si err.code === 401 -> pas loggué
               // Sinon c'est peut-être un pb de connexion...
               console.log('Erreur de format de données pour Confies RAL !');
               reject(new Error(err))
            }
         } else {
            reject(new Error('Pas de connection DB'))
         }
      })
   }, [addConfies, appWriteCollConfiesId, appWriteDatabaseId, client, db, last_updated_confies])

   const cleanConfies = useCallback(() => {
      return new Promise<void>(async (resolve, reject) => {
         if (db && client) {
            try {
               const docs = await db.listDocuments(appWriteDatabaseId, appWriteCollConfiesId, [
                  Query.select(['cust_id']),  // On n'a besoin que de l'ID pour purger
                  Query.limit(99999),
               ])

               console.log(`cleanConfies : ${docs.documents.length} docs`)
               if (docs.total > 0) {
                  const keep_ids = docs.documents.reduce((prev, a_doc) => {
                     // console.log(a_doc);
                     return new Set([...prev, a_doc.cust_id])
                  }, new Set())

                  console.log(`Keep ${keep_ids.size} Confies RAL ids`);

                  const all_customers = await dexie_db.confies.toCollection().toArray()

                  for (const a_customer of all_customers) {
                     const an_id = a_customer.id
                     if (!keep_ids.has(an_id)) {
                        console.log(`Delete customer ${an_id}`)
                        deleteConfies(an_id)
                     }
                  }
               }
               resolve()
            } catch (err) {
               // Si err.code === 401 -> pas loggué
               // Sinon c'est peut-être un pb de connexion...
               reject(new Error(err))
            }
         } else {
            reject(new Error('Pas de connection DB'))
         }
      })
   }, [appWriteCollConfiesId, appWriteDatabaseId, client, db, deleteConfies])

   /*
    ██████  ██████  ███    ██ ███████ ██ ███████ ███████     ██████   █████  ██
   ██      ██    ██ ████   ██ ██      ██ ██      ██          ██   ██ ██   ██ ██
   ██      ██    ██ ██ ██  ██ █████   ██ █████   ███████     ██████  ███████ ██
   ██      ██    ██ ██  ██ ██ ██      ██ ██           ██     ██   ██ ██   ██ ██
    ██████  ██████  ██   ████ ██      ██ ███████ ███████     ██   ██ ██   ██ ███████
   */

   // Fetch Reste à Livrer Confiés
   const buildConfiesRALObject = (appWriteObject) => {
      return {
         id: appWriteObject.cust_id,
         qte: appWriteObject.qte,
         // ca: appWriteObject.ca,
         ca_euro: appWriteObject.ca_euro,
         ca_dollar: appWriteObject.ca_dollar,
         last_updated: moment.utc(appWriteObject['$updatedAt']).toISOString(),
      }
   }

   const addConfiesRAL = useCallback(async (a_ral) => {
      let added = 0, updated = 0

      // console.log('addConfiesRAL', a_ral)
      const res = await dexie_db.confies_ral.get(a_ral.cust_id);
      if (res === undefined) {
         await dexie_db.confies_ral.add(buildConfiesRALObject(a_ral));
         added = 1
      } else {
         await dexie_db.confies_ral.put(buildConfiesRALObject(a_ral));
         updated = 1
      }
      return { added, updated }
   }, [])

   const deleteConfiesRAL = useCallback(async (an_id) => {
      try {
         await dexie_db.confies_ral.delete(an_id);
      } catch (err) {
         console.log(`Pb delete Confies RAL ${an_id}`, err);
      }
   }, [])

   const fetchConfiesRAL = useCallback((newLogin) => {
      return new Promise<void>(async (resolve, reject) => {
         let added = 0, updated = 0

         if (db && client) {
            try {
               const arr_queries = [
                  Query.limit(99999),
               ]
               const _last_updated_confies_ral = useSalesStore.getState().last_updated_confies_ral
               if (!newLogin && _last_updated_confies_ral) {
                  let dt_ref = moment.utc(_last_updated_confies_ral)

                  if (!dt_ref.isValid()) {
                     console.error(`last_updated_confies_ral (${_last_updated_confies_ral}) invalide.`)
                     dt_ref = moment.utc("2000-01-01")
                     console.error(`=> Fallback 2000-01-01. ${dt_ref}`)
                  }

                  arr_queries.push(Query.greaterThan('$updatedAt', dt_ref.toISOString()))
               }
               arr_queries.push(Query.orderAsc('$updatedAt'))
               console.log('last_updated_confies_ral', _last_updated_confies_ral);
               const docs = await db.listDocuments(appWriteDatabaseId, appWriteCollConfiesRALId, arr_queries)

               // console.log('fetchConfiesRAL', docs);
               if (docs.total === 0) {
                  resolve()
               } else {
                  for (const a_ral of docs.documents) {
                     const ret = await addConfiesRAL(a_ral)
                     added += ret.added
                     updated += ret.updated
                  }
                  console.log(`fetchConfiesRAL: added=${added}, updated=${updated}`);
                  resolve()
               }
            } catch (err) {
               // Si err.code === 401 -> pas loggué
               // Sinon c'est peut-être un pb de connexion...
               console.log('Erreur de format de données pour Confies RAL !');
               reject(new Error(err))
            }
         } else {
            reject(new Error('Pas de connection DB'))
         }
      })
   }, [addConfiesRAL, appWriteCollConfiesRALId, appWriteDatabaseId, client, db, last_updated_confies_ral])

   const cleanConfiesRAL = useCallback(() => {
      return new Promise<void>(async (resolve, reject) => {
         if (db && client) {
            try {
               const docs = await db.listDocuments(appWriteDatabaseId, appWriteCollConfiesRALId, [
                  Query.select(['cust_id']),  // On n'a besoin que de l'ID pour purger
                  Query.limit(99999),
               ])

               console.log(`cleanConfiesRAL : ${docs.documents.length} docs`)
               // if (docs.total > 0) {
               const keep_ids = docs.documents.reduce((prev, a_doc) => {
                  // console.log(a_doc);
                  return new Set([...prev, a_doc.cust_id])
               }, new Set())

               console.log(`Keep ${keep_ids.size} Confies RAL ids`);

               const all_customers = await dexie_db.confies_ral.toCollection().toArray()

               for (const a_customer of all_customers) {
                  const an_id = a_customer.id
                  if (!keep_ids.has(an_id)) {
                     console.log(`Delete Confies RAL for customer ${an_id}`)
                     deleteConfiesRAL(an_id)
                  }
               }
               // }
               resolve()
            } catch (err) {
               // Si err.code === 401 -> pas loggué
               // Sinon c'est peut-être un pb de connexion...
               reject(new Error(err))
            }
         } else {
            reject(new Error('Pas de connection DB'))
         }
      })
   }, [appWriteCollConfiesRALId, appWriteDatabaseId, client, db, deleteConfiesRAL])

   /*
   ████████  █████  ██████  ██ ███████ ███████
      ██    ██   ██ ██   ██ ██ ██      ██
      ██    ███████ ██████  ██ █████   ███████
      ██    ██   ██ ██   ██ ██ ██           ██
      ██    ██   ██ ██   ██ ██ ██      ███████
   */

   // Fetch générique pour collections, couleurs, cycles, etapes, familles, genres, portes
   const fetchTarif = useCallback((name, setTarif, checksum, setChecksum) => {
      return new Promise<void>((resolve, reject) => {
         console.log(`Fetch ${name} - CHK ${checksum}`)

         getCollectionItem(appWriteCollTarifsId, name, checksum ?? '').then(res => {
            if (res.status) {
               const doc = res.data

               if (doc) {  // On a fetché un doc plus récent
                  console.log(`fetch ${name} > OK`);
                  // console.log(doc.data);
                  // console.log(JSON.parse(doc.data));
                  // console.log(JSON.parse(doc.data));
                  try { // Permet de s'assurer que le JSON est OK
                     setTarif(JSON.parse(doc.data))
                     setChecksum(doc.checksum)
                     resolve()
                  } catch (err) {
                     console.log(`fetch ${name} > ERR`, err);
                     reject(new Error(err))
                  }
               } else {    // On n'a pas fetché de doc, donc pas trouvé de plus récent
                  console.log(`fetch ${name} > Doc null`);
                  if (!checksum) {  // Oui, mais on n'a rien actuellement dans la base, donc ça signifie qu'il y a un pb !
                     console.log(`fetch ${name} > ERR`);
                     reject(new Error(`${name}: Not found and no local data!`))
                  } else {    // On garde les data locales récupérées d'un fetch précédent
                     resolve()
                  }
               }
            } else {
               console.log(`fetch ${name} > ERR`, res);
               reject(new Error(res?.data?.message ?? 'Erreur inconnue'))
            }
         }).catch(err => {
            console.log(`fetch ${name} > ERR`, err);
            reject(new Error('Erreur inconnue'))
         })
      })
   }, [appWriteCollTarifsId, getCollectionItem])

   // regionToForce : nom de la région à charger même si elle n'est pas cochée "preload" (i.e. pour OFFLINE)
   // Sert quand on choisit une région qui est dans la liste mais pas encore en mémoire et pas preload
   // forOffLine = true permet de fetcher même si jamais fetché. Sinon c'est lors du login et on ne fetch
   // que si fetché et donc présent en mémoire.
   const fetchTarifsForSelectedRegions = useCallback((regionToForce, forOffLine, incDone) => {
      const arr = []

      console.log('fetchTarifsForSelectedRegions', tarif_regions)

      /* On utilise un Set pour éviter les doublons */
      let tarifs_to_fetch = new Set<string>()
      for (const key in tarif_regions) {
         const a_tarif = tarif_regions[key]
         // console.log(name)
         // if (a_tarif.preload || (key === regionToForce)) {  // Ancienne technique, pb détecté aux MDAYS 2024
         if (forOffLine || (key === regionToForce)) {  // Nv technique. On refetch si tarif en mémoire
            const names = [
               a_tarif.currencies.hjo.ces.tarif,
               a_tarif.currencies.hjo.ppu.tarif,
               a_tarif.currencies.other.ces.tarif,
               a_tarif.currencies.other.ppu.tarif
            ]
            console.log(`Tarif names "${key}" Add`, [...names])
            /* Tweak d'ajout d'un array de valeurs à un Set : on recréer un nv Set */
            tarifs_to_fetch = new Set([...tarifs_to_fetch, ...names])
         } else if (checksums_tarifs) {
            if (checksums_tarifs[a_tarif.currencies.hjo.ces.tarif]) {
               console.log(`Tarif names "${key}" Add ${a_tarif.currencies.hjo.ces.tarif}`)
               tarifs_to_fetch = new Set([...tarifs_to_fetch, a_tarif.currencies.hjo.ces.tarif])
            }
            if (checksums_tarifs[a_tarif.currencies.hjo.ppu.tarif]) {
               console.log(`Tarif names "${key}" Add ${a_tarif.currencies.hjo.ppu.tarif}`)
               tarifs_to_fetch = new Set([...tarifs_to_fetch, a_tarif.currencies.hjo.ppu.tarif])
            }
            if (checksums_tarifs[a_tarif.currencies.other.ces.tarif]) {
               console.log(`Tarif names "${key}" Add ${a_tarif.currencies.other.ces.tarif}`)
               tarifs_to_fetch = new Set([...tarifs_to_fetch, a_tarif.currencies.other.ces.tarif])
            }
            if (checksums_tarifs[a_tarif.currencies.other.ppu.tarif]) {
               console.log(`Tarif names "${key}" Add ${a_tarif.currencies.other.ppu.tarif}`)
               tarifs_to_fetch = new Set([...tarifs_to_fetch, a_tarif.currencies.other.ppu.tarif])
            }
         }
      }
      console.log('Tarifs à fetcher', tarifs_to_fetch)
      for (const key of tarifs_to_fetch) {
         // console.log(`Fetching prices /tarifs/tarif-${name}.json${compressedPrices ? ".gz" : ""}`)
         console.log(`Fetch tarif ${key}`, checksums_tarifs)
         arr.push(
            fetchTarif(key, (a_tarif) => {
               console.log(setTarifs, key, a_tarif);
               setTarifs(key, a_tarif)
            }, (checksums_tarifs ? checksums_tarifs[key] : null), (checksum) => {
               setChecksumsTarifs(key, checksum)
            }).finally(() => {
               incDone()
            })
         )
      }
      return arr
   }, [checksums_tarifs, fetchTarif, setChecksumsTarifs, setTarifs, tarif_regions])

   // regionToForce : nom de la région à charger même si elle n'est pas cochée "preload" (i.e. pour OFFLINE)
   // Sert quand on choisit une région qui est dans la liste mais pas encore en mémoire et pas preload
   // SI force === true, pas de vérif du checksum, tjs DL.
   const fetchTarifsForSingleRegion = useCallback((region_name, force, success, failure) => {
      console.log('fetchTarifsForSingleRegion', region_name)

      /* On utilise un Set pour éviter les doublons */
      let tarifs_to_fetch = new Set<string>()
      const a_tarif = tarif_regions[region_name]
      // console.log(name)
      // if (a_tarif?.in_list) {
      if (a_tarif) {
         const names = [
            a_tarif.currencies.hjo.ces.tarif,
            a_tarif.currencies.hjo.ppu.tarif,
            a_tarif.currencies.other.ces.tarif,
            a_tarif.currencies.other.ppu.tarif
         ]
         const arr = []
         console.log(`Tarif names "${region_name}" Add`, [...names])
         /* Tweak d'ajout d'un array de valeurs à un Set : on recréer un nv Set */
         tarifs_to_fetch = new Set([...tarifs_to_fetch, ...names])

         console.log('Tarifs à fetcher', tarifs_to_fetch)
         for (const key of tarifs_to_fetch) {
            // console.log(`Fetching prices /tarifs/tarif-${name}.json${compressedPrices ? ".gz" : ""}`)
            console.log(`Fetch tarif ${key}`, checksums_tarifs)
            arr.push(
               fetchTarif(key, (a_tarif) => {
                  console.log(setTarifs, key, a_tarif);
                  setTarifs(key, a_tarif)
               }, ((!force && checksums_tarifs) ? checksums_tarifs[key] : null), (checksum) => {
                  setChecksumsTarifs(key, checksum)
               })
            )
         }

         Promise.allSettled(arr).then(res => {
            const not_good = res.find(a_promise => a_promise.status !== 'fulfilled')
            console.log('Fini', res, not_good, not_good ? 'N' : 'Y');
            // setIsLogged(is_good)
            if (not_good) {
               failure((not_good as PromiseRejectedResult)?.reason?.message ?? trans("?Erreur de récupération des données"))
            } else {
               success()
            }
         })
      } else {
         // failure(trans("?Le tarif du client n'est pas dans votre liste !"))
         failure(trans("?Le tarif du client est inconnu !"))
      }
   }, [checksums_tarifs, fetchTarif, setChecksumsTarifs, setTarifs, tarif_regions, trans])

   /*
   ██████  ██████  ███████
   ██   ██ ██   ██ ██
   ██████  ██   ██ █████
   ██      ██   ██ ██
   ██      ██████  ██
   */

   // arr_data est un objet JSON
   const awPushPDF = useCallback((type, obj_data, emails, message) => {
      console.log('awPushPDF');
      return new Promise<void>(async (resolve, reject) => {
         if (db && client) {
            try {
               // Préparation du payload PDF (ECR/ECF : discount, défaut 0, sans remise ; sans jewels)
               const data_for_pdf = preparePdfData(type, obj_data, type_order)
               const obj = {
                  data: JSON.stringify(data_for_pdf),
                  type,
                  emails: [...emails, login],
                  lang: currentLang,
                  message,
               }
               try {
                  const id = ID.unique()
                  console.log(`createDocument()`, obj, id);
                  let meId: string | undefined
                  try { meId = (await account.get())?.$id } catch { /* pas de session : permissions par défaut */ }
                  await db.createDocument(appWriteDatabaseId, appWriteCollPDFId, id, obj, userOwnPermissions(meId))
               } catch (err) {
                  console.error('CreateDocument - CATCH ERR', err)
               }
               resolve()
            } catch (err) {
               reject(new Error(err))
            }
         } else {
            reject(new Error('Pas de connection DB'))
         }
      })
   }, [appWriteCollPDFId, appWriteDatabaseId, client, currentLang, db, login, type_order])

   /*
   ███████ ████████  █████  ██████  ████████ ██    ██ ██████
   ██         ██    ██   ██ ██   ██    ██    ██    ██ ██   ██
   ███████    ██    ███████ ██████     ██    ██    ██ ██████
        ██    ██    ██   ██ ██   ██    ██    ██    ██ ██
   ███████    ██    ██   ██ ██   ██    ██     ██████  ██
   */

   const initialFetch = useCallback(async (newLogin, success, failure, setTotal, incDone, fetchSubProgress) => {
      // Attendre la fin de l'hydratation du store `models` (lecture IndexedDB async) AVANT
      // de fetcher/écrire les listes : sinon l'hydratation tardive rejoue l'ancien snapshot
      // (vide) et écrase les données fraîchement posées (tarif_regions vide au 1er login
      // jusqu'à un reload). Symétrique de awaitPrefsHydrated() dans doLogin.
      await awaitModelsHydrated()
      // let total = 0
      // let done = 0
      console.log('last_updated_customers', last_updated_customers);
      console.log('last_updated_bi_orders', last_updated_bi_orders);
      console.log('last_updated_orders', last_updated_orders);
      const arr = [
         fetchList(fetch_names.collections, setCollections, checksum_collections, setChecksumCollections, () => useModelsStore.getState().collections).finally(() => {
            incDone()
         }),
         fetchList(fetch_names.sous_collections, setSousCollections, checksum_sous_collections, setChecksumSousCollections, () => useModelsStore.getState().sous_collections).finally(() => {
            incDone()
         }),
         fetchList(fetch_names.univers, setUnivers, checksum_univers, setChecksumUnivers, () => useModelsStore.getState().univers).finally(() => {
            incDone()
         }),
         fetchList(fetch_names.couleurs, setCouleurs, checksum_couleurs, setChecksumCouleurs, () => useModelsStore.getState().couleurs).finally(() => {
            incDone()
         }),
         fetchList(fetch_names.countries, setCountries, checksum_countries, setChecksumCountries, () => useSalesStore.getState().countries).finally(() => {
            incDone()
         }),
         fetchList(fetch_names.cycles, setCycles, checksum_cycles, setChecksumCycles, () => useModelsStore.getState().cycles).finally(() => {
            incDone()
         }),
         fetchList(fetch_names.devises, setDevises, checksum_devises, setChecksumDevises, () => useModelsStore.getState().devises).finally(() => {
            incDone()
         }),
         fetchList(fetch_names.etapes, setEtapes, checksum_etapes, setChecksumEtapes, () => useModelsStore.getState().etapes).finally(() => {
            incDone()
         }),
         fetchList(fetch_names.familles, setFamilles, checksum_familles, setChecksumFamilles, () => useModelsStore.getState().familles).finally(() => {
            incDone()
         }),
         fetchList(fetch_names.genres, setGenres, checksum_genres, setChecksumGenres, () => useModelsStore.getState().genres).finally(() => {
            incDone()
         }),
         fetchList(fetch_names.modeles, setModels, checksum_models, setChecksumModels, () => useModelsStore.getState().models).finally(() => {
            incDone()
         }),
         fetchList(fetch_names.retail_modeles, setRetailModels, checksum_retail_models, setChecksumRetailModels, () => useModelsStore.getState().retail_models).finally(() => {
            incDone()
         }),
         fetchList(fetch_names.retail_familles, setRetailFamilles, checksum_retail_familles, setChecksumRetailFamilles, () => useModelsStore.getState().retail_familles).finally(() => {
            incDone()
         }),
         fetchList(fetch_names.portes, setPortes, checksum_portes, setChecksumPortes, () => useModelsStore.getState().portes).finally(() => {
            incDone()
         }),
         fetchList(fetch_names.typologies, setTypologies, checksum_typologies, setChecksumTypologies, () => useModelsStore.getState().typologies).finally(() => {
            incDone()
         }),
         fetchList(fetch_names.tarif_trads, setTarifTrads, checksum_tarif_trads, setChecksumTarifTrads, () => useModelsStore.getState().tarif_trads).finally(() => {
            incDone()
         }),
         fetchList(fetch_names.tarif_regions, setTarifRegions, checksum_tarif_regions, setChecksumTarifRegions, () => useModelsStore.getState().tarif_regions).finally(() => {
            incDone()
         }),
         fetchCustomers(newLogin).finally(async () => {
            console.log('fetchCustomers - DONE');
            incDone()
            await cleanCustomers().finally(async () => {
               console.log('cleanCustomers - DONE');
               incDone()   // !!! Ne pas oublier de compter +1 plus bas
               setLastUpdatedCustomers(await findMostRecentUpdate('customers'))
            })
         }),
         fetchVentesRAL(newLogin).finally(async () => {
            console.log('fetchVentesRAL - DONE');
            incDone()
            await cleanVentesRAL().finally(async () => {
               console.log('cleanVentesRAL - DONE');
               incDone()   // !!! Ne pas oublier de compter +1 plus bas
               setLastUpdatedVentesRAL(await findMostRecentUpdate('ventes_ral'))
            })
         }),
         fetchConfies(newLogin).finally(async () => {
            console.log('fetchConfies - DONE');
            incDone()
            await cleanConfies().finally(async () => {
               console.log('cleanConfies - DONE');
               incDone()   // !!! Ne pas oublier de compter +1 plus bas
               setLastUpdatedConfies(await findMostRecentUpdate('confies'))
            })
         }),
         fetchConfiesRAL(newLogin).finally(async () => {
            console.log('fetchConfiesRAL - DONE');
            incDone()
            await cleanConfiesRAL().finally(async () => {
               console.log('cleanConfiesRAL - DONE');
               incDone()   // !!! Ne pas oublier de compter +1 plus bas
               setLastUpdatedConfiesRAL(await findMostRecentUpdate('confies_ral'))
            })
         }),
         // Fetch BI Orders
         fetchBiOrders(newLogin, fetchSubProgress).finally(async () => {
            incDone()
            // Watermark delta AVANT la purge : la purge locale (par date) ne doit pas faire
            // régresser le curseur $updatedAt (sinon un doc à date ancienne mais modifié
            // récemment reviendrait à chaque login).
            setLastUpdatedBiOrders(await findMostRecentUpdate('bi_orders'))
            await cleanBiOrders().finally(async () => {
               incDone()   // !!! Ne pas oublier de compter +1 plus bas
            })
         }),
         // Fetch Orders
         fetchOrders(newLogin, fetchSubProgress).finally(async () => {
            incDone()
            await cleanOrders().finally(async () => {
               incDone()   // !!! Ne pas oublier de compter +1 plus bas
            })
            setLastUpdatedOrders(await findMostRecentUpdate('orders'))
         }),
      ]

      const arr_tarifs = fetchTarifsForSelectedRegions(null, false, incDone)
      if (arr_tarifs.length > 0) {
         arr.push(arr_tarifs as any)
      }

      // Nb de tarifs + les listes +6 car on en a imbriqués dans des Promises et +1 permet d'afficher un bout de la barre de progression dès le départ
      setTotal(arr.length + 6 + 1)
      // done = 1

      Promise.allSettled(arr).then(res => {
         const not_good = res.find(a_promise => a_promise.status !== 'fulfilled')
         console.log('Fini', res, not_good, not_good ? 'N' : 'Y');
         // setIsLogged(is_good)
         if (not_good) {
            failure((not_good as PromiseRejectedResult)?.reason?.message ?? trans("?Erreur de récupération des données"))
            miscLogs('Pb initialFetch', res)
         } else {
            success()
            // miscLogs('OK initialFetch2', 'AAA')
            // miscLogs('OK initialFetch', [1, 2, res])
         }
      })

   }, [last_updated_customers, last_updated_bi_orders, last_updated_orders, fetchList, setCollections, checksum_collections, setChecksumCollections, setCouleurs, checksum_couleurs, setChecksumCouleurs, setCountries, checksum_countries, setChecksumCountries, setCycles, checksum_cycles, setChecksumCycles, setDevises, checksum_devises, setChecksumDevises, setEtapes, checksum_etapes, setChecksumEtapes, setFamilles, checksum_familles, setChecksumFamilles, setGenres, checksum_genres, setChecksumGenres, setModels, checksum_models, setChecksumModels, setPortes, checksum_portes, setChecksumPortes, setTypologies, checksum_typologies, setChecksumTypologies, setTarifTrads, checksum_tarif_trads, setChecksumTarifTrads, setTarifRegions, checksum_tarif_regions, setChecksumTarifRegions, fetchCustomers, fetchVentesRAL, fetchConfies, fetchConfiesRAL, fetchBiOrders, fetchOrders, fetchTarifsForSelectedRegions, cleanCustomers, setLastUpdatedCustomers, findMostRecentUpdate, cleanVentesRAL, setLastUpdatedVentesRAL, cleanConfies, setLastUpdatedConfies, cleanConfiesRAL, setLastUpdatedConfiesRAL, cleanBiOrders, setLastUpdatedBiOrders, cleanOrders, setLastUpdatedOrders, trans, miscLogs, awaitModelsHydrated])

   /*
   ███████ ██    ██ ██████  ███████  ██████ ██████  ██ ██████  ████████ ██  ██████  ███    ██ ███████
   ██      ██    ██ ██   ██ ██      ██      ██   ██ ██ ██   ██    ██    ██ ██    ██ ████   ██ ██
   ███████ ██    ██ ██████  ███████ ██      ██████  ██ ██████     ██    ██ ██    ██ ██ ██  ██ ███████
        ██ ██    ██ ██   ██      ██ ██      ██   ██ ██ ██         ██    ██ ██    ██ ██  ██ ██      ██
   ███████  ██████  ██████  ███████  ██████ ██   ██ ██ ██         ██    ██  ██████  ██   ████ ███████
   */

   /*
      Channels possibles : (https://appwrite.io/docs/realtime#channels)
      account :                 All account related events (session create, name update...)
      databases.[ID].collections.[ID].documents	: Any create/update/delete events to any document in a collection
      documents :               Any create/update/delete events to any document
      databases.[ID].collections.[ID].documents.[ID] : Any update/delete events to a given document
      files :                   Any create/update/delete events to any file
      buckets.[ID].files.[ID] : Any update/delete events to a given file of the given bucket
      buckets.[ID].files :      Any update/delete events to any file of the given bucket
      teams :                   Any create/update/delete events to a any team
      teams.[ID] :              Any update/delete events to a given team
      memberships :             Any create/update/delete events to a any membership
      memberships.[ID] :        Any update/delete events to a given membership
      executions :              Any update to executions
      executions.[ID] :         Any update to a given execution
      functions.[ID] :          Any execution event to a given function
    
      La fonction retournée sert à unsubscribe() mais ne coupe pas de WebSocket !
   */

   /**
    * Souscription aux modifs "live" des documents de paramétrage (modèles, collections, familles, portés etc.)
    */
   const subscribeToCollectionEvents = useCallback((collection_id, callback) => {
      if (client) {
         // console.log('SUB OK : subscribeToCollectionEvents', `databases.${appWriteDatabaseId}.collections.${collection_id}.documents`)
         const unsub = client.subscribe([
            // `databases.${appWriteDatabaseId}.collections.${collection_id}.documents`   // Anciennes appellations
            `databases.${appWriteDatabaseId}.tables.${collection_id}.rows`
         ], response => {
            // if (response.events.includes('databases.*.collections.*.documents.*.create')) {
            // console.log(response, response.payload)
            // const dt = Date.parse(response.payload.$updatedAt)
            // console.log('>>', response.payload.$updatedAt, dt, new Date().toISOString(), Date.now(), Date.now() - dt, new Date().getTime() - dt)
            if (callback) {
               callback(response)
            }
            // }
         })
         // console.log('SUB', unsub)
         return unsub
         // return () => {
         //    console.log('ICI...', unsub)
         //    console.log('Call unsub')
         //    unsub()
         // }
      } else {
         return null
      }
   }, [appWriteDatabaseId, client])

   // Les listes
   useEffect(() => {
      // Anciennes appellations AppWrite
      // const prefix = `databases.${appWriteDatabaseId}.collections.${appWriteCollListsId}.documents`
      // Nouvelles appellations AppWrite (collections => tables, documents => rows)
      const prefix = `databases.${appWriteDatabaseId}.tables.${appWriteCollListsId}.rows`

      // console.log('SUB CanSubscribe? ', isLogged ? 'Yes' : 'No');
      if (isLogged) {
         console.log('ICI >>> subscribeToCollectionEvents >>>>2');
         // console.log('SUB Go sub...');
         const unsub = subscribeToCollectionEvents(appWriteCollListsId, (event) => {
            console.log(event);
            try {
               if (
                  event.events.includes(`${prefix}.${fetch_names.collections}.create`) ||
                  event.events.includes(`${prefix}.${fetch_names.collections}.update`)
               ) {
                  console.log('Event collections !');
                  setCollections(JSON.parse(event?.payload?.data))
                  setChecksumCollections(event?.payload?.checksum)
               } else if (
                  event.events.includes(`${prefix}.${fetch_names.couleurs}.create`) ||
                  event.events.includes(`${prefix}.${fetch_names.couleurs}.update`)
               ) {
                  console.log('Event couleurs !');
                  setCouleurs(JSON.parse(event?.payload?.data))
                  setChecksumCouleurs(event?.payload?.checksum)
               } else if (
                  event.events.includes(`${prefix}.${fetch_names.countries}.create`) ||
                  event.events.includes(`${prefix}.${fetch_names.countries}.update`)
               ) {
                  console.log('Event countries !');
                  setCountries(JSON.parse(event?.payload?.data))
                  setChecksumCountries(event?.payload?.checksum)
               } else if (
                  event.events.includes(`${prefix}.${fetch_names.cycles}.create`) ||
                  event.events.includes(`${prefix}.${fetch_names.cycles}.update`)
               ) {
                  console.log('Event cycles !');
                  setCycles(JSON.parse(event?.payload?.data))
                  setChecksumCycles(event?.payload?.checksum)
               } else if (
                  event.events.includes(`${prefix}.${fetch_names.devises}.create`) ||
                  event.events.includes(`${prefix}.${fetch_names.devises}.update`)
               ) {
                  console.log('Event devises !');
                  setDevises(JSON.parse(event?.payload?.data))
                  setChecksumDevises(event?.payload?.checksum)
               } else if (
                  event.events.includes(`${prefix}.${fetch_names.etapes}.create`) ||
                  event.events.includes(`${prefix}.${fetch_names.etapes}.update`)
               ) {
                  console.log('Event etapes !');
                  setEtapes(JSON.parse(event?.payload?.data))
                  setChecksumEtapes(event?.payload?.checksum)
               } else if (
                  event.events.includes(`${prefix}.${fetch_names.familles}.create`) ||
                  event.events.includes(`${prefix}.${fetch_names.familles}.update`)
               ) {
                  console.log('Event familles !');
                  setFamilles(JSON.parse(event?.payload?.data))
                  setChecksumFamilles(event?.payload?.checksum)
               } else if (
                  event.events.includes(`${prefix}.${fetch_names.genres}.create`) ||
                  event.events.includes(`${prefix}.${fetch_names.genres}.update`)
               ) {
                  console.log('Event genres !');
                  setGenres(JSON.parse(event?.payload?.data))
                  setChecksumGenres(event?.payload?.checksum)
               } else if (
                  event.events.includes(`${prefix}.${fetch_names.modeles}.create`) ||
                  event.events.includes(`${prefix}.${fetch_names.modeles}.update`)
               ) {
                  console.log('Event modeles !');
                  setModels(JSON.parse(event?.payload?.data))
                  setChecksumModels(event?.payload?.checksum)
               } else if (
                  event.events.includes(`${prefix}.${fetch_names.portes}.create`) ||
                  event.events.includes(`${prefix}.${fetch_names.portes}.update`)
               ) {
                  console.log('Event portes !');
                  setPortes(JSON.parse(event?.payload?.data))
                  setChecksumPortes(event?.payload?.checksum)
               } else if (
                  event.events.includes(`${prefix}.${fetch_names.typologies}.create`) ||
                  event.events.includes(`${prefix}.${fetch_names.typologies}.update`)
               ) {
                  console.log('Event typologies !');
                  setTypologies(JSON.parse(event?.payload?.data))
                  setChecksumTypologies(event?.payload?.checksum)
               } else {
                  console.log('Event inconnu !', event.events);
               }
            } catch (err) {
               console.log('Erreur de format de données pour Collections !');
            }
         })
         return (() => {   // Unmount, on unsub()
            // console.log('SUB unmount useEffect (>>>>2)');
            if (unsub) {
               // console.log('SUB unsub (unmount >>>>2)');
               unsub()
            }
         })
      }
   }, [appWriteCollListsId, appWriteDatabaseId, isLogged, setChecksumCollections, setChecksumCouleurs, setChecksumCountries, setChecksumCycles, setChecksumDevises, setChecksumEtapes, setChecksumFamilles, setChecksumGenres, setChecksumModels, setChecksumPortes, setCollections, setCouleurs, setCountries, setCycles, setDevises, setEtapes, setFamilles, setGenres, setModels, setPortes, subscribeToCollectionEvents])

   // Les clients
   useEffect(() => {
      // Anciennes appellations AppWrite
      // const prefix = `databases.${appWriteDatabaseId}.collections.${appWriteCollCustomersId}.documents.*`
      // Nouvelles appellations AppWrite (collections => tables, documents => rows)
      const prefix = `databases.${appWriteDatabaseId}.tables.${appWriteCollCustomersId}.rows.*`

      // console.log('SUB CanSubscribe? ', isLogged ? 'Yes' : 'No');
      if (isLogged) {
         // console.log('ICI >>> subscribeToCollectionEvents >>>>1');
         // console.log('SUB Go sub custo...');
         const unsub = subscribeToCollectionEvents(appWriteCollCustomersId, async (event) => {
            // console.log(event, prefix);
            try {
               if (
                  event.events.includes(`${prefix}.create`) ||
                  event.events.includes(`${prefix}.update`)
               ) {
                  // console.log('Event customers !');
                  await addCustomer(event.payload)
                  // console.log(ret.added ? 'Added' : 'Updated');
                  // setCollections(JSON.parse(event?.payload?.data))
                  // setChecksumCollections(event?.payload?.checksum)
               } else if (event.events.includes(`${prefix}.delete`)) {
                  // console.log('Event customers (delete) !');
                  await deleteCustomer(event.payload.number)
               } else {
                  console.error('Event inconnu !', event.events);
               }
            } catch (err) {
               console.error('Erreur de format de données pour Customers !');
            }
         })
         return (() => {   // Unmount, on unsub()
            // console.log('SUB unmount useEffect (>>>>1)');
            if (unsub) {
               // console.log('SUB unsub (unmount >>>>2)');
               unsub()
            }
         })
      }
   }, [addCustomer, appWriteCollCustomersId, appWriteDatabaseId, deleteCustomer, isLogged, subscribeToCollectionEvents])

   // Les commandes (locales, donc hors BI). Permet aussi de sync des appareils distincts loggués sur le même compte
   useEffect(() => {
      // Anciennes appellations AppWrite
      // const prefix = `databases.${appWriteDatabaseId}.collections.${appWriteCollOrdersId}.documents.*`
      // Nouvelles appellations AppWrite (collections => tables, documents => rows)
      const prefix = `databases.${appWriteDatabaseId}.tables.${appWriteCollOrdersId}.rows.*`

      // console.log('SUB CanSubscribe? ', isLogged ? 'Yes' : 'No');
      if (isLogged) {
         // console.log('ICI >>> subscribeToCollectionEvents >>>>1');
         // console.log('SUB Go sub orders...');
         const unsub = subscribeToCollectionEvents(appWriteCollOrdersId, async (event) => {
            // console.log(event, prefix);
            try {
               if (
                  event.events.includes(`${prefix}.create`) ||
                  event.events.includes(`${prefix}.update`)
               ) {
                  // console.log('Event orders !', event.payload);
                  const doc = await getOrderById(event.payload.id)
                  if (!doc || !doc.last_pushed || (moment().diff(doc.last_pushed, 'seconds') > glob_const.min_delay_on_push)) {
                     await addOrder(event.payload)
                     // console.log(ret.added ? 'Added' : 'Updated');
                  } else {
                     console.log('Too quick, not updated (only last_updated)!');
                     await updateOrderLocally(event.payload.id, { last_updated: moment.utc(event.payload['$updatedAt']).toISOString() })
                     setLastUpdatedOrders(await findMostRecentUpdate('orders'))
                  }
               } else if (event.events.includes(`${prefix}.delete`)) {
                  // console.log('Event orders (delete) !');
                  await deleteLocalOrder(event.payload.id)
               } else {
                  console.error('Event inconnu !', event.events);
               }
            } catch (err) {
               console.error('Erreur de format de données pour Orders !');
            }
         })
         return (() => {   // Unmount, on unsub()
            // console.log('SUB unmount useEffect (>>>>1)');
            if (unsub) {
               // console.log('SUB unsub (unmount >>>>2)');
               unsub()
            }
         })
      }
   }, [addOrder, appWriteCollOrdersId, appWriteDatabaseId, deleteLocalOrder, findMostRecentUpdate, getOrderById, isLogged, setLastUpdatedOrders, subscribeToCollectionEvents, updateOrderLocally])

   return (
      <theContext.Provider value={{ context: theContext, client, account, currentUserId, doLogin, doLogout, setUserAbsence, getStock, fetchOtp, otp, setOtp, getCollectionItem, initialFetch, subscribeToCollectionEvents, fetchTarifsForSelectedRegions, fetchTarifsForSingleRegion, awPushOrder, awPushWaitingOrders, awDeleteOrder, awFixOrderPermissions, awSendOrderToClient, awSubmitOrder, awValidateN2, awValidateN1, awReturnToClient, awReconcileOrder, awPushPDF, awPushUdid, awEnsureUniqueUdidPrefix, verifOtp, resetPasswordOtp, sendResetPin, resetPasswordPin, addFakeLocalCustomer, awConsumeForcedSync }}>
         {children}
      </theContext.Provider>
   )
}

export { AppWriteContext, AppWriteContextProvider }